<template>
  <div>
    <CModal :show="cookies" fullHeight position="center">
      <mdbModalHeader center :close="true" slot="header" class="p-0 m-0">
        <p class="heading m-0">
          <mdb-icon icon="exclamation-circle" class="icono-error m-2" />
          Información
        </p>
      </mdbModalHeader>
      <mdbModalBody class="text-center">
        <p class="center">{{ message }}</p>
      </mdbModalBody>
      <mdbModalFooter center slot="footer" class="m-0">
        <CButton color="primary" @click="cookies = false">OK</CButton>
      </mdbModalFooter>
    </CModal>

    <!-- Message Popup -->
    <CModal
      title="Send Message"
      color="dark"
      fullHeight
      position="center"
      size="lg"
      centered=true
      :show.sync="openThirdPopup"
    >
      <CCard class="pt-2">
        <!-- <CCardHeader class="text-left p-4"></CCardHeader> -->
        <CCardBody style="height: 400px; overflow-y: auto">
          <CRow class="p-0 border-bottom">
            <semipolar-spinner
              :animation-duration="2000"
              :size="30"
              color="blue"
              v-if="isLoading"
            ></semipolar-spinner>
            <!-- <div class="col-md-12" v-if="itemreviews.length == 0">
                No Review
              </div> -->
            <div class="col-md-12" v-if="itemreviews.length > 0">
              <div class="message" v-if="!isLoading">
                <CRow
                  class="col-sm-12 mb-2"
                  v-if="itemreviewselected.reviewReply !== false"
                >
                  <div class="text-truncate font-weight-bold">Respuesta:</div>

                  <div class="col-sm-12 text-muted p-2">
                    {{ itemreviewselected.reviewReply }}
                    <small class="text-muted float-right">{{
                      getdateConverted(itemreviewselected.reply_updateTime)
                    }}</small>
                  </div>
                </CRow>
                <CRow>
                  <div class="col-sm-12 pt-3">
                    <!-- <CInput placeholder="Answer should be here" name="input_answer" /> -->
                    <!--<mdb-input
                      class="mb-3 mt-0"
                      placeholder="Answer should be here"
                      v-model="reply_text"
                      required
                    ></mdb-input>-->
                    <div class="newPop">
                      <div>
                        <div
                              class="c-avatar"
                              v-if="itemreviewselected.url_reviewer_photo !== false"
                              style="width: 40px; height: 40px"
                            >
                              <img
                                class="c-avatar-img"
                                :src="getImage(itemreviewselected.url_reviewer_photo)"
                                alt="user@email.com"
                              />
                              <!-- <span class="c-avatar-status bg-success"></span> -->
                            </div>
                            <div
                              class="c-avatar"
                              style="width: 40px; height: 40px"
                              v-else
                            >
                              <img
                                class="c-avatar-img"
                                src="img/logo_brand.png"
                                alt="user@email.com"
                              />
                              <!-- <span class="c-avatar-status bg-success"></span> -->
                            </div>
                            <div>
                              <span>{{itemreviewselected.reviewer_name}} <small>({{itemreviewselected.location_city}})</small></span>
                              <br>
                            </div>
                      </div>
                      <div>
                        <span>{{itemreviewselected.createTime}}</span><br><br>
                    <span
                              class="text-muted float-right"
                              v-for="(star, index) in itemreviewselected.starRating"
                              :key="index"
                            >
                              <i class="fa fa-star" aria-hidden="true"></i>
                            </span>
                      </div>
                   
                    </div>
                    <br>
                    <span>{{itemreviewselected.comment}}</span>
                    
                    <CTextarea placeholder="Answer should be here" style="margin-top:2% !important;" rows="4" v-model='reply_text'></CTextarea>
                  </div>

                  <div class="col-sm-12 mt-2 pb-2">
                    <!-- <span class="float-left mr-2">
                      <CIcon name="cilCommentSquare"></CIcon>
                      </span>-->
                    <span class="float-left mr-2">
                      <emoji-picker @emoji="insert" :search="search">
                        <!--  -->
                        <div
                          class="emoji-invoker"
                          slot="emoji-invoker"
                          slot-scope="{ events: { click: clickEvent } }"
                          @click.stop="clickEvent"
                        >
                          <CIcon name="cilSmile"></CIcon>
                        </div>

                        <div
                          slot="emoji-picker"
                          slot-scope="{ emojis, insert }"
                        >
                          <div class="emoji-picker">
                            <div class="emoji-picker__search">
                              <input type="text" v-model="search" v-focus />
                            </div>
                            <div>
                              <div
                                v-for="(emojiGroup, category) in emojis"
                                :key="category"
                              >
                                <h5>{{ category }}</h5>
                                <div class="emojis">
                                  <span
                                    v-for="(emoji, emojiName) in emojiGroup"
                                    :key="emojiName"
                                    @click="insert(emoji)"
                                    :title="emojiName"
                                    >{{ emoji }}</span
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </emoji-picker>
                    </span>
                    <span>
                      <CButton
                        color="dark"
                        class="float-right p-2"
                        v-if="itemreviewselected.reviewReply === false"
                        @click="
                          reviewReplySubmit(itemreviewselected.id);
                          openThirdPopup = false;
                        "
                        >Enviar</CButton
                      >
                      <CBadge
                        color="danger"
                        class="float-right p-2 ml-2"
                        v-if="itemreviewselected.reviewReply !== false"
                        @click="
                          reviewReplySubmit(itemreviewselected.id);
                          openThirdPopup = false;
                        "
                        >Editar respuesta</CBadge
                      >
                      <CBadge
                        color="danger"
                        class="float-right p-2"
                        v-if="itemreviewselected.reviewReply !== false"
                        @click="reviewReplyDelete(itemreviewselected.id)"
                        >Eliminar respuesta</CBadge
                      >
                    </span>
                  </div>
                </CRow>
              </div>
            </div>
            <div v-else>No Review</div>
          </CRow>
        </CCardBody>
      </CCard>
      <template #footer-wrapper>
        <div class="d-none">aaa</div>
      </template>
    </CModal>

    <!-- Partner Detail Popup -->
    <CModal
      title="Review Detail"
      color="info"
      fullHeight
      position="center"
      size="lg"
      centered=true
      :show.sync="openFourthPopup"
    >
      <CCard class="pt-2" style="max-height: 400px; overflow-y: auto">
        <CCardHeader class="text-left p-2">
          <CBadge color="light" class="float-right ml-2 p-2">
            <i style="font-size: 15px" class="fa fa-cog" aria-hidden="true"></i>
          </CBadge>
          <!-- <CBadge color="light" class="float-right text-primary p-2">
              <CIcon name="cibLinkedinIn"></CIcon>
            </CBadge> -->
        </CCardHeader>
        <CCardBody>
          <div v-if="itemreviews.length > 0">
            <CRow class="p-3 border-bottom">
              <semipolar-spinner
                :animation-duration="2000"
                :size="30"
                color="blue"
                v-if="isLoading"
              ></semipolar-spinner>

              <div class="message col-sm-12" v-if="!isLoading">
                <CRow>
                  <div class="mb-n3">
                    <div
                      class="c-avatar"
                      v-if="itemreviewselected.url_reviewer_photo !== false"
                      style="width: 100px; height: 100px; z-index: 999"
                    >
                      <img
                        class="c-avatar-img"
                        :src="getImage(itemreviewselected.url_reviewer_photo)"
                        alt="user@email.com"
                      />
                      <!-- <span class="c-avatar-status bg-success"></span> -->
                    </div>
                    <div
                      class="c-avatar"
                      style="width: 40px; height: 40px"
                      v-else
                    >
                      <img
                        class="c-avatar-img"
                        src="img/logo_brand.png"
                        alt="user@email.com"
                      />
                      <!-- <span class="c-avatar-status bg-success"></span> -->
                    </div>
                    <!--  <div class="c-avatar" style="width:100px; height:100px; z-index:999">
                        <img class="c-avatar-img" src="img/logo_brand.png" alt="user@email.com" />
                      </div> -->
                  </div>
                </CRow>
                <!-- <CBadge color="light" class="mt-n5 ml-4">
                    <CIcon name="cil-star" style=" width:20px;height:20px;z-index:998" />
                  </CBadge> -->
                <CRow>
                  <div>
                    <div class="text-muted font-weight-bold mt-3 ml-4">
                      {{ itemreviewselected.reviewer_name }}
                    </div>
                  </div>
                </CRow>
                <!--<div class="small text-muted font-weight-bold">@lluispascualmartinez</div>
                <div class="text-muted font-weight-bold mt-2">CMO &amp; Business</div>

                <div class="text-muted font-weight-bold">Development EMEA at 3D</div>
                  <div class="text-muted font-weight-bold">Digital Venue</div>-->
              </div>
            </CRow>

            <CRow class="p-3 border-bottom" v-if="type_Selected == 'location'">
              <div class="message col-sm-12" v-if="parter3days">
                <div class="message col-sm-12">
                  <CRow v-if="itemreviewselected.location_id !== false"
                    ><span>
                      <strong>Location name : </strong>&nbsp;&nbsp;&nbsp;
                      {{ itemreviewselected.location_id[1] }}</span
                    >
                  </CRow>
                  <CRow
                    ><span
                      ><strong>Description : </strong>
                      {{ itemreviewselected.description }}</span
                    >
                  </CRow>
                  <CRow>
                    <span
                      ><strong>Primary phone : </strong
                      >{{ itemreviewselected.primaryPhone }}</span
                    >
                  </CRow>
                  <CRow>
                    <span
                      ><strong>Website Url : </strong>
                      <CLink
                        :href="selectedlocation.websiteUrl"
                        target="_blank"
                        >{{ selectedlocation.websiteUrl }}</CLink
                      ></span
                    >
                  </CRow>
                  <!-- <CRow>
                  <span><strong>Maps Url : </strong><a target="_blank" :href="selectedlocation.maps_url" @click.stop>{{selectedlocation.maps_url}}</a></span>
                </CRow> -->
                  <CRow v-if="itemreviewselected.location_maps_url != false">
                    <span
                      ><strong>Maps Url : </strong
                      ><CLink
                        :href="itemreviewselected.location_maps_url"
                        target="_blank"
                        >{{ itemreviewselected.location_maps_url }}</CLink
                      ></span
                    >
                  </CRow>
                  <CRow>
                    <span
                      ><strong>Address : </strong
                      >{{ itemreviewselected.location_address }}</span
                    >
                  </CRow>
                  <CRow>
                    <span
                      ><strong>City : </strong
                      >{{ itemreviewselected.location_city }}</span
                    >
                  </CRow>
                  <!-- <CRow>
                  <span><strong>ZipCode : </strong>{{selectedlocation.zip_code}}</span>
                </CRow> -->
                  <!-- <CRow><span>
                  <strong>Average rating : </strong>
                  {{selectedlocation.averageRating}}
                </span>
                </CRow> -->
                  <CRow
                    ><span>
                      <strong>Total review count : </strong
                      >{{ itemreviews.length }}</span
                    >
                  </CRow>
                  <CRow v-if="itemreviewselected.partner_id">
                    <span>
                      <strong>Partner : </strong
                      >{{ itemreviewselected.partner_id[1] }}</span
                    >
                  </CRow>
                </div>
              </div>
              <div v-else>
                <div class="message col-sm-12">
                  <CRow
                    ><span>
                      <strong>Location name : </strong>&nbsp;&nbsp;&nbsp;
                      {{
                        selectedlocation.locationName
                          ? selectedlocation.locationName
                          : selectedlocation.name
                      }}</span
                    >
                  </CRow>
                  <CRow
                    ><span
                      ><strong>Description : </strong>
                      {{ selectedlocation.description }}</span
                    >
                  </CRow>
                  <CRow>
                    <span
                      ><strong>Primary phone : </strong
                      >{{
                        selectedlocation.primaryPhone
                          ? selectedlocation.primaryPhone
                          : selectedlocation.phone
                      }}</span
                    >
                  </CRow>
                  <CRow>
                    <span
                      ><strong>Website Url : </strong>
                      <CLink
                        :href="selectedlocation.websiteUrl"
                        target="_blank"
                        >{{
                          selectedlocation.websiteUrl
                            ? selectedlocation.websiteUrl
                            : selectedlocation.web
                        }}</CLink
                      ></span
                    >
                  </CRow>
                  <!-- <CRow>
                  <span><strong>Maps Url : </strong><a target="_blank" :href="selectedlocation.maps_url" @click.stop>{{selectedlocation.maps_url}}</a></span>
                </CRow> -->
                  <CRow>
                    <span
                      ><strong>Maps Url : </strong
                      ><CLink
                        :href="selectedlocation.maps_url"
                        target="_blank"
                        >{{
                          selectedlocation.maps_url
                            ? selectedlocation.maps_url
                            : selectedlocation.trustpilot_url
                        }}</CLink
                      ></span
                    >
                  </CRow>
                  <CRow>
                    <span
                      ><strong>Address : </strong
                      >{{ selectedlocation.address }}</span
                    >
                  </CRow>
                  <CRow>
                    <span
                      ><strong>City : </strong>{{ selectedlocation.city }}</span
                    >
                  </CRow>
                  <CRow>
                    <span
                      ><strong>ZipCode : </strong
                      >{{ selectedlocation.zip_code }}</span
                    >
                  </CRow>
                  <CRow
                    ><span>
                      <strong>Average rating : </strong>
                      {{
                        selectedlocation.averageRating
                          ? selectedlocation.averageRating
                          : selectedlocation.score
                      }}
                    </span>
                  </CRow>
                  <CRow
                    ><span>
                      <strong>Total review count : </strong
                      >{{
                        selectedlocation.totalReviewCount
                          ? selectedlocation.totalReviewCount
                          : selectedlocation.review_count
                      }}</span
                    >
                  </CRow>
                  <CRow v-if="selectedlocation.partner_id">
                    <span>
                      <strong>Partner : </strong
                      >{{ selectedlocation.partner_id.name }}</span
                    >
                  </CRow>
                </div>
              </div>
            </CRow>

            <CRow class="p-3 border-bottom" v-if="type_Selected == 'page'">
              <div class="message col-sm-12">
                <CRow
                  ><span>
                    <strong>Name : </strong>&nbsp;&nbsp;&nbsp;
                    {{ page_selected.name }}</span
                  >
                </CRow>
                <CRow
                  ><span>
                    <strong>Category : </strong>&nbsp;&nbsp;&nbsp;
                    {{ page_selected.category }}</span
                  >
                </CRow>
                <CRow
                  ><span>
                    <strong>Average Rating : </strong>&nbsp;&nbsp;&nbsp;
                    {{ page_selected.averageRating }}</span
                  >
                </CRow>
                <CRow
                  ><span>
                    <strong>Total Review Count : </strong>&nbsp; &nbsp;&nbsp;{{
                      page_selected.totalReviewCount
                    }}</span
                  >
                </CRow>
              </div>
            </CRow>
          </div>
          <div v-else>No Review</div>
        </CCardBody>
      </CCard>
      <template #footer-wrapper>
        <div class="d-none">aaa</div>
      </template>
    </CModal>

    <CRow>
      <div v-bind:class="[isActive ? 'col-lg-6 col-md-12 col-xs-12 col-sm-12 firstcol p-0' : 'hide']" id="kill">
        <CCard class="pt-0">
          <CCardBody>
            <div style="overflow-y: auto" class="firstcol-list-wrapper">
              <CRow class="pl-3 p-2">
                <label class="typo__label font-weight-bold"> Partner </label>
                <multiselect
                  v-model="partnerSelected"
                  placeholder="Seleccione un Partner"
                  label="value"
                  track-by="id"
                  :options="partners"
                  :close-on-select="true"
                  :clear-on-select="false"
                  @input="getfilterlocationNamePartner()"
                  :multiple="false"
                  :taggable="true"
                ></multiselect>
              </CRow>

              <CRow class="mb-3">
                <div class="col-sm-6">
                  <label class="typo__label font-weight-bold"> Platform </label>
                  <multiselect
                    v-model="platformSelected"
                    placeholder="Seleccione un Platform"
                    label="name"
                    track-by="name"
                    :options="platforms"
                    :close-on-select="true"
                    :clear-on-select="false"
                    @input="getfilterplatform()"
                    :multiple="false"
                    :taggable="true"
                  ></multiselect>
                </div>
                <div class="col-sm-6">
                  <label class="typo__label font-weight-bold"> City </label>
                  <multiselect
                    v-model="citySelected"
                    placeholder="Seleccione un City"
                    label="name"
                    track-by="name"
                    :options="city"
                    :close-on-select="true"
                    :clear-on-select="false"
                    @input="getfilterlocationNameCity()"
                    :multiple="false"
                    :taggable="true"
                  ></multiselect>
                </div>
              </CRow>

              <CCard v-if="!isLocationLoading" class="p-0 m-0 mb-3 border">
                <div v-if="Object.keys(partnerSelected).length > 0">
                  <CListGroupItem
                    @click="showDetails"
                    class="col-sm-12 p-1 pt-2 pb-2"
                    :class="{ active: parter3days }"
                  >
                    {{ this.partnerSelected.value }} General
                    <CBadge color="danger float-right " shape="pill">{{
                      porContestar_general
                    }}</CBadge>
                  </CListGroupItem>
                </div>
                <CCardBody class="p-0">
                  <CListGroup
                    class="p-0 mt-4 pb-4 pt-2 list-item-wrapper"
                    accent
                  >
                    <!-- v-if="item.gmbaccount_id.id == item_account.id" -->

                    <CListGroupItem
                      tag="li"
                      href="#"
                      v-for="(item, index) in itemlocations"
                      :key="index"
                      class="p-3 mb-2"
                      @click="
                        item.locationName
                          ? showIdDetails(item, item.id)
                          : showIdDetails_businessUnit(item, item.id)
                      "
                      color="light"
                      accent="light"
                      :class="{
                        active: item.locationName
                          ? selected_location == item.id
                          : selected_bu == item.id,
                      }"
                    >
                      <div
                        class="boton-pregunta"
                        data-toggle="tooltip"
                        data-placement="right"
                        :title="getString(item)"
                      >
                        {{ item.locationName ? item.locationName : item.name }}
                        <div v-if="item.locationName">
                          <small class="message" v-if="getString(item) !== ''"
                            >({{ getString(item) }})</small
                          >
                          <small class="message" v-if="getString1(item) !== ''"
                            ><br />({{ getString1(item) }})</small
                          >

                          <CBadge color="danger float-right " shape="pill">{{
                            getnoreplylocation(item.id)
                          }}</CBadge>
                          <small class="message float-right mr-3">
                            <i
                              style="color: blue"
                              v-if="selected_location !== item.id"
                              class="fab fa-google"
                            ></i>
                            <i
                              style="color: white"
                              v-if="selected_location === item.id"
                              class="fab fa-google"
                            ></i>
                          </small>
                        </div>
                        <div v-else>
                          <!-- <small class="message">({{getString(item)}})</small> -->
                          <small class="message" v-if="getString(item) !== ''"
                            >({{ getString(item) }})</small
                          >
                          <small class="message" v-if="getStringbu(item) !== ''"
                            ><br />({{ getStringbu(item) }})</small
                          >
                          <CBadge color="danger float-right " shape="pill">{{
                            getnoreplybu(item.id)
                          }}</CBadge>
                          <small
                            class="message float-right mr-3"
                            style="color: green"
                          >
                            <i
                              style="color: white"
                              v-if="selected_bu == item.id"
                              class="fas fa-star"
                            ></i>
                            <i
                              style="color: green"
                              v-if="selected_bu !== item.id"
                              class="fas fa-star"
                            ></i>
                          </small>
                        </div>
                      </div>
                    </CListGroupItem>
                  </CListGroup>
                </CCardBody>
              </CCard>
              <CCard class="col-sm-12 p-0" v-if="itempages.length > 0">
                <CCardBody class="col-sm-12 p-0">
                  <CListGroup accent>
                    <CListGroupItem
                      href="#"
                      v-for="(item_page, i) in itempages"
                      :key="i"
                      class="col-sm-12 p-1 pt-2 pb-2"
                      @click="showIdDetailsPage(item_page, item_page.id)"
                      color="light"
                      accent="light"
                      :class="{ active: selected_page == item_page.id }"
                    >
                      <div
                        class="boton-pregunta"
                        data-toggle="tooltip"
                        data-placement="right"
                        :title="getString(item_page)"
                      >
                        <div v-if="selected_page === item_page.id">
                          {{ item_page.name }}

                          <CBadge color="danger float-right " shape="pill"
                            >{{ getnoreplypages(item_page.id) }}
                          </CBadge>
                          <small
                            class="message float-right mr-3"
                            style="color: white"
                            ><i class="fab fa-facebook-f"></i
                          ></small>
                        </div>

                        <div v-else>
                          {{ item_page.name }}
                          <CBadge color="danger float-right " shape="pill">{{
                            getnoreplypages(item_page.id)
                          }}</CBadge>
                          <small
                            class="message float-right mr-3"
                            style="color: blue"
                            ><i class="fab fa-facebook-f"></i
                          ></small>
                        </div>
                      </div>
                    </CListGroupItem>
                  </CListGroup>
                </CCardBody>
              </CCard>
            </div>
          </CCardBody>
        </CCard>
      </div>

      <div v-bind:class="[isActive ? 'col-lg-6 col-md-12 col-xs-12 col-sm-12 p-0' : 'change']" id="live">
        <CCard>
          <CCardBody class="pt-3">
            <CRow class="tabnav" slot="tabnav">
              <div class="col-md-10">
                <!-- {{respondidos_tab}} {{all_tab}} -->
                <CNav variant="tabs" class="p-0">
                  <CNavItem
                    active
                    @click.native="getFilterreviews('noreviewReply')"
                  >
                    Por responder
                    <CBadge v-if="parter3days" color="warning">{{
                      porContestar_general
                    }}</CBadge>
                    <CBadge v-else color="warning">{{ porContestar }}</CBadge>
                  </CNavItem>
                  <CNavItem @click.native="getFilterreviews('reviewReply')"
                    >Respondidos</CNavItem
                  >
                  <CNavItem @click.native="getFilterreviews('all')"
                    >Todo

                    <CBadge color="warning">
                      <!-- <span v-if="type_Selected=='location' && !parter3days && type_Selected!=='page'">{{selectedlocation.locationName ? selectedlocation.totalReviewCount : selectedlocation.review_count}}</span>

                      <span v-if="parter3days">{{porContestar_general}}</span> -->

                      <!-- 
                      <span v-if="type_Selected=='page' && type_Selected!=='location'">{{totalreviews}}</span> -->
                      <span>{{ totalreviews }}</span>
                    </CBadge>
                  </CNavItem>
                </CNav>
              </div>
              <div class="col-md-1 flexear">

                <div>
                <CBadge color="light" class="float-right p-1">
                  <CDropdown color=" p-0" placement="bottom-end">
                    <template #toggler-content>
                      <i class="fa fa-sort-amount-asc" aria-hidden="true"></i>
                      <!-- <CIcon name="cil-settings" /> -->
                    </template>
                    <!-- <CDropdownItem @click.native="getSortedreviews('reviewReplyAsc')" >reviewReply  <i class="fa fa-sort-alpha-asc ml-2" aria-hidden="true"></i></CDropdownItem>
                    <CDropdownItem @click.native="getSortedreviews('reviewReplyDesc')">reviewReply  <i class="fa fa-sort-alpha-desc  ml-2" aria-hidden="true"></i></CDropdownItem>-->
                    <CDropdownItem
                      @click.native="getSortedreviews('createTimeAsc')"
                    >
                      createTime
                      <i
                        class="fa fa-sort-amount-asc ml-2"
                        aria-hidden="true"
                      ></i>
                    </CDropdownItem>
                    <CDropdownItem
                      @click.native="getSortedreviews('createTimeDesc')"
                    >
                      createTime
                      <i
                        class="fa fa-sort-amount-desc ml-2"
                        aria-hidden="true"
                      ></i>
                    </CDropdownItem>
                  </CDropdown>
                </CBadge>
                  </div>
                  <div class="boxbutton">
                
                <!-- <CBadge color="light" class="float-right p-2">
                  <i class="fa fa-check" aria-hidden="true"></i>
                </CBadge>-->
                  </div>
                  <cButton v-if="this.active = this.active" class="hideButton" @click="bootChange()" color="light"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
                  </svg></cButton>

                  <cButton v-if="this.active = !this.active" class="hideButton" @click="bootChange()" color="light"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
                  </svg></cButton>
              </div>
            </CRow>
            <CRow class="p-3">
              <CCol>
                <CBadge color="light" class="float-right">
                  <CDropdown placement="bottom-end">
                    <template #toggler-content>
                      <i class="fa fa-filter" aria-hidden="true"></i> Filtros
                      <!-- <CIcon name="cil-settings" /> -->
                    </template>
                    <div v-if="scoreTagsvisible === true" class="border-bottom">
                      <CDropdownHeader
                        tag="div"
                        class="text-center"
                        color="light"
                      >
                        <strong>Score Tag</strong>
                      </CDropdownHeader>
                      <CDropdownItem
                        @click.native="
                          getFilterreviewsSelected('scoreTags', item)
                        "
                        v-for="(item, key) in scoreTags"
                        :key="key"
                        :class="{ active: scoreTagSelected === item }"
                        >{{ item }}</CDropdownItem
                      >
                    </div>
                    <CDropdownHeader
                      tag="div"
                      class="text-center"
                      color="light"
                    >
                      <strong>Star Rating</strong>
                    </CDropdownHeader>
                    <CDropdownItem
                      @click.native="
                        getFilterreviewsSelected('starRating', item)
                      "
                      v-for="(item, key) in starRating"
                      :key="key"
                      :class="{ active: starRatingSelected === item }"
                      >{{ item }}</CDropdownItem
                    >
                  </CDropdown>
                </CBadge>
                

                <CBadge color="light" class="float-right mr-2">
                  <!-- <i class="fa fa-calendar" v-on="on" aria-hidden="true">
                    
                  </i>-->
                  <date-picker
          v-model="range"
          range
          :shortcuts="shortcuts"
          confirm
          @change="dateSelected(range)"
        ></date-picker>
                </CBadge>
              </CCol>
            </CRow>

            <div style="height: 645px; overflow-y: auto">
              <semipolar-spinner
                :animation-duration="2000"
                :size="30"
                color="blue"
                v-if="isLoadingReviewmain"
              ></semipolar-spinner>

              <CRow class="p-0">
                <CListGroup
                  class="col-md-12 p-3"
                  name="reviews"
                  :flush="reviewflush"
                >
                  <div class="message p-3" v-if="itemreviews.length === 0">
                    No Reviews...
                  </div>
                  <template v-if="!isLoading">
                    <CListGroupItem
                      href="#"
                      v-for="(item, index) in itemreviews"
                      :key="index"
                      class="message col-sm-12 p-3 border-bottom"
                      style="flex:auto;"
                    >
                      <div v-if="itemreviews.length > 0">
                        <div>
                          <div class="py-2 mfe-3 float-left">
                            <div
                              class="c-avatar"
                              v-if="item.url_reviewer_photo !== false"
                              style="width: 40px; height: 40px"
                            >
                              <img
                                class="c-avatar-img"
                                :src="getImage(item.url_reviewer_photo)"
                                alt="user@email.com"
                              />
                              <!-- <span class="c-avatar-status bg-success"></span> -->
                            </div>
                            <div
                              class="c-avatar"
                              style="width: 40px; height: 40px"
                              v-else
                            >
                              <img
                                class="c-avatar-img"
                                src="img/logo_brand.png"
                                alt="user@email.com"
                              />
                              <!-- <span class="c-avatar-status bg-success"></span> -->
                            </div>
                            <div class="pl-3" v-if="item.business_unit_id">
                              <i style="color: green" class="fas fa-star"></i>
                            </div>
                            <div class="pl-3" v-if="type_Selected == 'page'">
                              <i
                                style="color: blue"
                                class="fab fa-facebook-f"
                              ></i>
                            </div>
                            <div
                              class="pl-3"
                              v-if="
                                !item.business_unit_id &&
                                type_Selected !== 'page' &&
                                !parter3days
                              "
                            >
                              <i style="color: blue" class="fab fa-google"></i>
                            </div>
                          </div>
                          <div class="col-sm-12">
                            
                            <span
                              class="text-muted float-right"
                              v-for="(star, index) in item.starRating"
                              :key="index"
                            >
                              <i class="fa fa-star" aria-hidden="true"></i>
                            </span>

                            <span class="text-muted float-right mr-2">{{
                              getdateConverted(item.createTime)
                            }}</span>
                            
                            <span class="float-right mr-2 text-success" v-if="item.score_tag == 'P+' || item.score_tag == 'P'">
                              {{ item.score_tag }}
                            </span>

                            <span class="text-muted float-right mr-2" v-if="item.score_tag == 'NONE' || item.score_tag == 'NEU'">
                              {{ item.score_tag }}
                            </span>

                            <span class="float-right mr-2 text-danger" v-if="item.score_tag == 'N+' || item.score_tag == 'N'">
                              {{ item.score_tag }}
                            </span>

                          </div>
                          <div class="text-truncate font-weight-bold">
                            {{ item.reviewer_name }}
                          </div>

                          <!-- <small  v-if="item.business_unit_id && type_Selected!=='page'" class="message">({{getStringBuReview(item)}})</small> -->
                          <div v-if="!selectedlocation.locationName">
                            <p>If</p>
                            <small
                              v-if="
                                type_Selected !== 'page' &&
                                getStringReviewbu(type_Selected, item) !== ''
                              "
                              class="message"
                              >({{
                                getStringReviewbu(type_Selected, item)
                              }})</small
                            >
                            <small
                              v-if="
                                type_Selected !== 'page' &&
                                getStringReviewbu1(
                                  type_Selected,
                                  selectedlocation
                                ) !== ''
                              "
                              class="message"
                              ><br />({{
                                getStringReviewbu1(
                                  type_Selected,
                                  selectedlocation
                                )
                              }})</small
                            >
                          </div>
                          <div v-else>
                            <small
                              v-if="
                                type_Selected !== 'page' &&
                                getStringReview(type_Selected, item) !== ''
                              "
                              class="message"
                              >({{
                                getStringReview(type_Selected, item)
                              }})</small
                            >
                            <small
                              v-if="
                                type_Selected !== 'page' &&
                                getStringReview1(
                                  type_Selected,
                                  selectedlocation
                                ) !== ''
                              "
                              class="message"
                              ><br />({{
                                getStringReview1(
                                  type_Selected,
                                  selectedlocation
                                )
                              }})</small
                            >
                          </div>
                          <div
                            class="medium mt-3"
                            v-if="item.comment !== false"
                          >
                            <span v-if="!item.translateToggle">
                              {{ item.comment }}
                            </span>
                            <span v-if="item.translateToggle">
                              {{ item.comment_eng }}
                            </span>
                          </div>
                          <div
                            class="medium mt-3"
                            v-if="item.comment === false"
                          >
                            Sin comentarios.
                          </div>
                          <div v-if="item.comment !== false" class="mb-3">
                            <CBadge
                              style="font-size: 13px"
                              color="secondary"
                              shape="pill"
                              v-if="item.translateToggle == false"
                              @click="
                                itemreviews[index].translateToggle =
                                  !itemreviews[index].translateToggle
                              "
                            >
                              Ver traducción
                            </CBadge>

                            <CBadge
                              style="font-size: 13px"
                              color="secondary"
                              shape="pill"
                              v-if="item.translateToggle == true"
                              @click="
                                itemreviews[index].translateToggle =
                                  !itemreviews[index].translateToggle
                              "
                              >Ver original</CBadge
                            >
                          </div>

                          <div
                            class="border-top border-bottom pt-2 pb-2"
                            v-if="item.reviewReply !== false"
                          >
                            <div class="text-truncate font-weight-bold">
                              Respuesta:
                            </div>

                            <div class="text-muted">
                              {{ item.reviewReply }}
                              <small class="text-muted float-right">{{
                                getdateConverted(item.reply_updateTime)
                              }}</small>
                            </div>
                          </div>

                          <div class="col-sm-12 pb-4 pl-0 mt-3">

                            <CButton color="dark"
                              class="p-2 mr-2"
                              @click="
                                openThirdPopup = true;
                                showreviewDetails(item);
                              ">
                                Responder
                            </CButton>
                            

                            <CButton
                              color="dark"
                              class="p-2"
                              @click="
                                openFourthPopup = true;
                                showreviewDetails(item);
                              "
                            >
                              Información
                            </CButton>
                            <CButton class="float-right ml-2 p-2" color="secondary" v-if="item.resolved === false" v-on:click="item.resolved = !item.resolved, resolvedChange(item.id,item.resolved)">Pendiente</CButton>
                            <CButton class="float-right ml-2 p-2" color="success" v-if="item.resolved !== false" v-on:click="item.resolved = !item.resolved, resolvedChange(item.id,item.resolved)">Resuelto</CButton>
                            <CSelect placeholder="Cambiar Sentimiento" :options="scoreTags" v-model="scoreTagSelected" style="width=100px" class="float-right ml-2 p-2" @change="scoreTagChange(item.id, scoreTagSelected.target.value),getfilterlocationNamePartner()"></CSelect>
                          </div>
                        </div>
                      </div>
                    </CListGroupItem>
                  </template>
                </CListGroup>

                <div
                  class="ml-5"
                  v-if="type_Selected !== 'page' && !parter3days"
                >
                  <div v-if="loadMore_review">
                    <scroll-loader
                      :loader-method="
                        selectedlocation.locationName
                          ? getReviews
                          : getReviewsBusinessUnit
                      "
                      :loader-enable="loadMore_review"
                    >
                      <semipolar-spinner
                        :animation-duration="2000"
                        :size="30"
                        color="blue"
                      ></semipolar-spinner>
                    </scroll-loader>
                  </div>
                </div>

                <div class="ml-5" v-if="parter3days">
                  <div v-if="loadMore_review">
                    <scroll-loader
                      :loader-method="getReviewslast3days"
                      :loader-enable="loadMore_review"
                    >
                      <semipolar-spinner
                        :animation-duration="2000"
                        :size="30"
                        color="blue"
                      ></semipolar-spinner>
                    </scroll-loader>
                  </div>
                </div>
                <div class="ml-5" v-if="type_Selected === 'page'">
                  <div v-if="loadMore_review">
                    <scroll-loader
                      :loader-method="getReviewsPages"
                      :loader-enable="loadMore_review"
                    >
                      <semipolar-spinner
                        :animation-duration="2000"
                        :size="30"
                        color="blue"
                      ></semipolar-spinner>
                    </scroll-loader>
                  </div>
                </div>
              </CRow>
            </div>
          </CCardBody>
        </CCard>
      </div>

      <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0 d-none">
        <CCard class="pt-2">
          <CCardHeader class="text-left p-4"></CCardHeader>
          <CCardBody style="height: 730px; overflow-y: auto">
            <CRow class="p-0 border-bottom">
              <semipolar-spinner
                :animation-duration="2000"
                :size="30"
                color="blue"
                v-if="isLoading"
              ></semipolar-spinner>
              <!-- <div class="col-md-12" v-if="itemreviews.length == 0">
                No Review
              </div> -->
              <div class="col-md-12" v-if="itemreviews.length > 0">
                <div class="message col-sm-12" v-if="!isLoading">
                  <div class="py-2 mfe-3 float-left">
                    <div
                      class="c-avatar"
                      v-if="itemreviewselected.url_reviewer_photo !== false"
                      style="width: 40px; height: 40px"
                    >
                      <img
                        class="c-avatar-img"
                        :src="getImage(itemreviewselected.url_reviewer_photo)"
                        alt="user@email.com"
                      />
                      <!-- <span class="c-avatar-status bg-success"></span> -->
                    </div>
                    <div
                      class="c-avatar"
                      style="width: 40px; height: 40px"
                      v-else
                    >
                      <img
                        class="c-avatar-img"
                        src="img/logo_brand.png"
                        alt="user@email.com"
                      />
                      <!-- <span class="c-avatar-status bg-success"></span> -->
                    </div>

                    <!-- <div class="c-avatar" style="width:60px; height:60px">
                      <img class="c-avatar-img" src="img/logo_brand.png" alt="user@email.com" />
                    </div> -->
                  </div>
                  <div class="col-md-12">
                    <!-- <span class="text-muted float-right ml-2">
                    <CIcon name="cibPinboard" />
                    </span>-->
                    <span class="text-muted float-right">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </span>
                    <!-- <span class="text-muted float-right ml-2">
                    <i class="fa fa-bookmark" aria-hidden="true"></i>
                  </span>
                  <span class="text-muted float-right">
                    <i class="fa fa-tag" aria-hidden="true"></i>
                    </span>-->
                  </div>
                  <div class="text-truncate font-weight-bold">
                    {{ itemreviewselected.reviewer_name }}
                  </div>
                  <div>
                    <small class="text-muted"
                      >{{ getdateConverted(itemreviewselected.createTime) }}
                    </small>
                  </div>
                  <div class="col-md-12 medium" v-if="translation == true">
                    <div v-if="itemreviewselected.comment_eng === false">
                      No Comments.
                    </div>
                    <div v-if="itemreviewselected.comment_eng !== false">
                      {{ itemreviewselected.comment_eng }}
                    </div>
                  </div>
                  <div class="col-md-12 medium" v-if="translation == false">
                    <div v-if="itemreviewselected.comment === false">
                      Sin comentarios.
                    </div>
                    <div v-if="itemreviewselected.comment !== false">
                      {{ itemreviewselected.comment }}
                    </div>
                  </div>
                  <div
                    class="medium mt-3 pb-3 border-bottom"
                    @click="translate(translation)"
                  >
                    <span v-if="translation == false">Ver traducción</span>
                    <span v-if="translation == true">Ver original</span>
                  </div>

                  <!--<div class="col-sm-12">
                  <span class="float-right ml-2 p-2">1 Respuestas</span>
                </div>

                <div class="mt-2 pb-2 border-bottom">
                  <span class="float-left mr-2">
                    <i class="fa fa-heart" aria-hidden="true"></i>
                  </span>
                  <span>1</span>
                  <span>
                    <i class="fa fa-dot" aria-hidden="true"></i> Me gusta
                  </span>
                  </div>-->

                  <!-- <CRow>
                  <div class="col-sm-12 pt-3">
                    <CBadge color="primary" class="mr-3 p-2">
                      <i class="fa fa-share mfe-2" aria-hidden="true"></i> Responder
                    </CBadge>
                    <CBadge color="light" class="p-2">
                      <i class="fa fa-user mfe-2" aria-hidden="true"></i> Assigner
                    </CBadge>
                    <CBadge color="light" class="float-right p-2">
                      <i class="fa fa-check mfe-2 text-success" aria-hidden="true"></i> Revisar
                    </CBadge>
                  </div>
                  </CRow>-->
                  <CRow
                    class="col-sm-12 mt-2 mb-2"
                    v-if="itemreviewselected.reviewReply !== false"
                  >
                    <div class="text-truncate font-weight-bold">Respuesta:</div>

                    <div class="col-sm-12 text-muted p-2">
                      {{ itemreviewselected.reviewReply }}
                      <small class="text-muted float-right">{{
                        getdateConverted(itemreviewselected.reply_updateTime)
                      }}</small>
                    </div>
                  </CRow>
                  <CRow>
                    <!--<div class="col-sm-6 pt-3">Mencionar en tu comentario</div>
                  <div class="col-sm-6 pt-3">
                    <span>
                      <CInputCheckbox label="Lluis Pascal" name="checkbox-1" />
                    </span>
                    </div>-->

                    <div class="col-sm-12 pt-3">
                      <!-- <CInput placeholder="Answer should be here" name="input_answer" /> -->
                      <mdb-input
                        class="mb-3 mt-0"
                        placeholder="Answer should be here"
                        v-model="reply_text"
                        required
                      ></mdb-input>
                    </div>

                    <div class="col-sm-12 mt-2 pb-2">
                      <!-- <span class="float-left mr-2">
                      <CIcon name="cilCommentSquare"></CIcon>
                      </span>-->
                      <span class="float-left mr-2">
                        <emoji-picker @emoji="insert" :search="search">
                          <!--  -->
                          <div
                            class="emoji-invoker"
                            slot="emoji-invoker"
                            slot-scope="{ events: { click: clickEvent } }"
                            @click.stop="clickEvent"
                          >
                            <CIcon name="cilSmile"></CIcon>
                          </div>

                          <div
                            slot="emoji-picker"
                            slot-scope="{ emojis, insert}"
                          >
                            <div class="emoji-picker">
                              <div class="emoji-picker__search">
                                <input type="text" v-model="search" v-focus />
                              </div>
                              <div>
                                <div
                                  v-for="(emojiGroup, category) in emojis"
                                  :key="category"
                                >
                                  <h5>{{ category }}</h5>
                                  <div class="emojis">
                                    <span
                                      v-for="(emoji, emojiName) in emojiGroup"
                                      :key="emojiName"
                                      @click="insert(emoji)"
                                      :title="emojiName"
                                      >{{ emoji }}</span
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </emoji-picker>
                      </span>
                      <span>
                        <CBadge
                          color="danger"
                          class="float-right p-2"
                          v-if="itemreviewselected.reviewReply === false"
                          @click="reviewReplySubmit(itemreviewselected.id)"
                          >Enviar</CBadge
                        >
                        <CBadge
                          color="danger"
                          class="float-right p-2 ml-2"
                          v-if="itemreviewselected.reviewReply !== false"
                          @click="reviewReplySubmit(itemreviewselected.id)"
                          >Editar respuesta</CBadge
                        >
                        <CBadge
                          color="danger"
                          class="float-right p-2"
                          v-if="itemreviewselected.reviewReply !== false"
                          @click="reviewReplyDelete(itemreviewselected.id)"
                          >Eliminar respuesta</CBadge
                        >
                      </span>
                    </div>
                  </CRow>
                </div>
              </div>
              <div v-else>No Review</div>
            </CRow>
          </CCardBody>
        </CCard>
        <CRow>
          <CCol class="col-12">
            <CCardBody></CCardBody>
          </CCol>
        </CRow>
      </div>

      <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0 d-none">
        <CCard class="pt-2" style="height: 790px; overflow-y: auto">
          <CCardHeader class="text-left p-2">
            <CBadge color="light" class="float-right ml-2 p-2">
              <i
                style="font-size: 15px"
                class="fa fa-cog"
                aria-hidden="true"
              ></i>
            </CBadge>
            <!-- <CBadge color="light" class="float-right text-primary p-2">
              <CIcon name="cibLinkedinIn"></CIcon>
            </CBadge> -->
          </CCardHeader>
          <CCardBody>
            <div v-if="itemreviews.length > 0">
              <CRow class="p-3 border-bottom">
                <semipolar-spinner
                  :animation-duration="2000"
                  :size="30"
                  color="blue"
                  v-if="isLoading"
                ></semipolar-spinner>

                <div class="message col-sm-12" v-if="!isLoading">
                  <CRow>
                    <div class="mb-n3">
                      <div
                        class="c-avatar"
                        v-if="itemreviewselected.url_reviewer_photo !== false"
                        style="width: 100px; height: 100px; z-index: 999"
                      >
                        <img
                          class="c-avatar-img"
                          :src="getImage(itemreviewselected.url_reviewer_photo)"
                          alt="user@email.com"
                        />
                        <!-- <span class="c-avatar-status bg-success"></span> -->
                      </div>
                      <div
                        class="c-avatar"
                        style="width: 40px; height: 40px"
                        v-else
                      >
                        <img
                          class="c-avatar-img"
                          src="img/logo_brand.png"
                          alt="user@email.com"
                        />
                        <!-- <span class="c-avatar-status bg-success"></span> -->
                      </div>
                      <!--  <div class="c-avatar" style="width:100px; height:100px; z-index:999">
                        <img class="c-avatar-img" src="img/logo_brand.png" alt="user@email.com" />
                      </div> -->
                    </div>
                  </CRow>
                  <!-- <CBadge color="light" class="mt-n5 ml-4">
                    <CIcon name="cil-star" style=" width:20px;height:20px;z-index:998" />
                  </CBadge> -->
                  <CRow>
                    <div>
                      <div class="text-muted font-weight-bold mt-3 ml-4">
                        {{ itemreviewselected.reviewer_name }}
                      </div>
                    </div>
                  </CRow>
                  <!--<div class="small text-muted font-weight-bold">@lluispascualmartinez</div>
                <div class="text-muted font-weight-bold mt-2">CMO &amp; Business</div>

                <div class="text-muted font-weight-bold">Development EMEA at 3D</div>
                  <div class="text-muted font-weight-bold">Digital Venue</div>-->
                </div>
              </CRow>

              <CRow
                class="p-3 border-bottom"
                v-if="type_Selected == 'location'"
              >
                <div class="message col-sm-12" v-if="parter3days">
                  <div class="message col-sm-12">
                    <CRow v-if="itemreviewselected.location_id !== false"
                      ><span>
                        <strong>Location name : </strong>&nbsp;&nbsp;&nbsp;
                        {{ itemreviewselected.location_id[1] }}</span
                      >
                    </CRow>
                    <CRow
                      ><span
                        ><strong>Description : </strong>
                        {{ itemreviewselected.description }}</span
                      >
                    </CRow>
                    <CRow>
                      <span
                        ><strong>Primary phone : </strong
                        >{{ itemreviewselected.primaryPhone }}</span
                      >
                    </CRow>
                    <CRow>
                      <span
                        ><strong>Website Url : </strong>
                        <CLink
                          :href="selectedlocation.websiteUrl"
                          target="_blank"
                          >{{ selectedlocation.websiteUrl }}</CLink
                        ></span
                      >
                    </CRow>
                    <!-- <CRow>
                  <span><strong>Maps Url : </strong><a target="_blank" :href="selectedlocation.maps_url" @click.stop>{{selectedlocation.maps_url}}</a></span>
                </CRow> -->
                    <CRow v-if="itemreviewselected.location_maps_url != false">
                      <span
                        ><strong>Maps Url : </strong
                        ><CLink
                          :href="itemreviewselected.location_maps_url"
                          target="_blank"
                          >{{ itemreviewselected.location_maps_url }}</CLink
                        ></span
                      >
                    </CRow>
                    <CRow>
                      <span
                        ><strong>Address : </strong
                        >{{ itemreviewselected.location_address }}</span
                      >
                    </CRow>
                    <CRow>
                      <span
                        ><strong>City : </strong
                        >{{ itemreviewselected.location_city }}</span
                      >
                    </CRow>
                    <!-- <CRow>
                  <span><strong>ZipCode : </strong>{{selectedlocation.zip_code}}</span>
                </CRow> -->
                    <!-- <CRow><span>
                  <strong>Average rating : </strong>
                  {{selectedlocation.averageRating}}
                </span>
                </CRow> -->
                    <CRow
                      ><span>
                        <strong>Total review count : </strong
                        >{{ itemreviews.length }}</span
                      >
                    </CRow>
                    <CRow v-if="itemreviewselected.partner_id">
                      <span>
                        <strong>Partner : </strong
                        >{{ itemreviewselected.partner_id[1] }}</span
                      >
                    </CRow>
                  </div>
                </div>
                <div v-else>
                  <div class="message col-sm-12">
                    <CRow
                      ><span>
                        <strong>Location name : </strong>&nbsp;&nbsp;&nbsp;
                        {{
                          selectedlocation.locationName
                            ? selectedlocation.locationName
                            : selectedlocation.name
                        }}</span
                      >
                    </CRow>
                    <CRow
                      ><span
                        ><strong>Description : </strong>
                        {{ selectedlocation.description }}</span
                      >
                    </CRow>
                    <CRow>
                      <span
                        ><strong>Primary phone : </strong
                        >{{
                          selectedlocation.primaryPhone
                            ? selectedlocation.primaryPhone
                            : selectedlocation.phone
                        }}</span
                      >
                    </CRow>
                    <CRow>
                      <span
                        ><strong>Website Url : </strong>
                        <CLink
                          :href="selectedlocation.websiteUrl"
                          target="_blank"
                          >{{
                            selectedlocation.websiteUrl
                              ? selectedlocation.websiteUrl
                              : selectedlocation.web
                          }}</CLink
                        ></span
                      >
                    </CRow>
                    <!-- <CRow>
                  <span><strong>Maps Url : </strong><a target="_blank" :href="selectedlocation.maps_url" @click.stop>{{selectedlocation.maps_url}}</a></span>
                </CRow> -->
                    <CRow>
                      <span
                        ><strong>Maps Url : </strong
                        ><CLink
                          :href="selectedlocation.maps_url"
                          target="_blank"
                          >{{
                            selectedlocation.maps_url
                              ? selectedlocation.maps_url
                              : selectedlocation.trustpilot_url
                          }}</CLink
                        ></span
                      >
                    </CRow>
                    <CRow>
                      <span
                        ><strong>Address : </strong
                        >{{ selectedlocation.address }}</span
                      >
                    </CRow>
                    <CRow>
                      <span
                        ><strong>City : </strong
                        >{{ selectedlocation.city }}</span
                      >
                    </CRow>
                    <CRow>
                      <span
                        ><strong>ZipCode : </strong
                        >{{ selectedlocation.zip_code }}</span
                      >
                    </CRow>
                    <CRow
                      ><span>
                        <strong>Average rating : </strong>
                        {{
                          selectedlocation.averageRating
                            ? selectedlocation.averageRating
                            : selectedlocation.score
                        }}
                      </span>
                    </CRow>
                    <CRow
                      ><span>
                        <strong>Total review count : </strong
                        >{{
                          selectedlocation.totalReviewCount
                            ? selectedlocation.totalReviewCount
                            : selectedlocation.review_count
                        }}</span
                      >
                    </CRow>
                    <CRow v-if="selectedlocation.partner_id">
                      <span>
                        <strong>Partner : </strong
                        >{{ selectedlocation.partner_id.name }}</span
                      >
                    </CRow>
                  </div>
                </div>
              </CRow>

              <CRow class="p-3 border-bottom" v-if="type_Selected == 'page'">
                <div class="message col-sm-12">
                  <CRow
                    ><span>
                      <strong>Name : </strong>&nbsp;&nbsp;&nbsp;
                      {{ page_selected.name }}</span
                    >
                  </CRow>
                  <CRow
                    ><span>
                      <strong>Category : </strong>&nbsp;&nbsp;&nbsp;
                      {{ page_selected.category }}</span
                    >
                  </CRow>
                  <CRow
                    ><span>
                      <strong>Average Rating : </strong>&nbsp;&nbsp;&nbsp;
                      {{ page_selected.averageRating }}</span
                    >
                  </CRow>
                  <CRow
                    ><span>
                      <strong>Total Review Count : </strong>&nbsp;
                      &nbsp;&nbsp;{{ page_selected.totalReviewCount }}</span
                    >
                  </CRow>
                </div>
              </CRow>
            </div>
            <div v-else>No Review</div>
          </CCardBody>
        </CCard>
      </div>
    </CRow>
  </div>
</template>

<script >
// import MainChartExample from './charts/MainChartExample'
// import WidgetsDropdown from './widgets/WidgetsDropdown'
// import WidgetsBrand from './widgets/WidgetsBrand'
import store from "../../store";
// import XmlAjaxRequest from '../../store/GlobalAPiCall';
// import UrlMethods from '../../store/UrlMethods';

import { shuffleArray } from "@/shared/utils";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/scss/index.scss";
import moment from "moment";
import { mdbInput } from "mdbvue";
import EmojiPicker from "vue-emoji-picker";
// import VEmojiPicker from 'v-emoji-picker';
import { SemipolarSpinner } from "epic-spinners";
import Treeselect from "@riophae/vue-treeselect";
import Multiselect from "vue-multiselect";
import axios from "axios";
import ScrollLoader from "vue-scroll-loader";

// Vue.use(ScrollLoader)
import {
  mdbBtn,
  mdbIcon,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
} from "mdbvue";

export default {
  name: "Actions",
  components: {
    DatePicker,
    mdbInput,
    EmojiPicker,
    SemipolarSpinner,
    Treeselect,
    Multiselect,
    mdbBtn,
    mdbIcon,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
  },
  data() {
    return {
      isActive: true,
      open: false,
      input: "",
      search: "",
      accordion: 0,
      cardCollapse: false,
      cardCollapse0: false,
      cardCollapse1: false,
      locationflush: true,
      pagesflush: true,
      reviewflush: true,
      locationName: "",
      partner_search: "",
      city_search_location: "",
      selected_location: 2,
      selected_bu: 99999,
      selected_page: 999,
      selected_tab: "reviewReply",
      date: "", //new Date(),//new Date().toISOString().substr(0, 10),
      time: "",
      range: "",
      selected: "Month",
      items: [],
      selected_item: {},
      idNumber: 0,
      idNumber_bu: 0,
      comentario_selected: "",
      porContestar: 0,
      porContestar_general: 0,
      translation: false,
      reply_text: "",
      location_info: "",
      review_id: "",
      starRating: ["1", "2", "3", "4", "5"],
      starRatingvisible: true,
      scoreTags: ["P+", "P", "NONE", "NEU", "N+", "N"],
      scoreTagsvisible: true,
      tableItems: [
        {
          avatar: { url: "img/avatars/6.jpg", status: "danger" },
          user: {
            name: "Friderik Dávid",
            new: true,
            registered: "Jan 1, 2015",
          },
          country: { name: "Poland", flag: "cif-pl" },
          usage: { value: 43, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "Amex", icon: "cib-cc-amex" },
          activity: "Last week",
        },
      ],
      tableFields: [{ key: "Perfiles Sociales", label: "", _classes: "" }],
      itemlocations: [],
      businessUnits: [],
      itemlocations_city: [],
      itemlocationsArray: [],
      partnerSelectedlocations: [],
      itempages: [],
      selected_tab: "noreviewReply",
      itempagesArray: [],
      itemreviews: [],
      itemreviews_data: [],
      itemreviews1: [],
      itemreviews_data1: [],
      itemreviewselected: {},
      itemconversations: [],
      gmbAccounts: [],
      isLoading: false,
      isLoadingReview: false,
      isLoadingReviewmain: false,
      isLocationLoading: false,
      selectedlocation: {},
      por_responder_tab: "active",
      respondidos_tab: "",
      all_tab: "",
      type_Selected: "location",
      search_review: "",
      cookies: false,
      message: "",
      partners: [],
      partnersArray: [],
      partnerSelected: {},
      platformSelected: {},
      citySelected: {},
      city: [],
      platforms: [
        { name: "GMB", value: "GMB" },
        { name: "Trustpilot", value: "Trustpilot" },
        { name: "Facebook", value: "Facebook" },
      ],
      cityArray: [],
      partner_ids: [],
      itemsArray: [],
      parter3days: false,
      noreplycount_location_data: [],
      noreplycount_bu_data: [],
      noreplycount_page_data: [],
      page_selected: {},
      offset_location: 0,
      offset_review: 0,
      scrollPosition: 0,
      loadMore: false,
      loadMore_review: false,
      page: 1,
      totalreviews: 0,
      starRatingSelected: "",
      scoreTagSelected: "",
      reviewType: "",
      openFourthPopup: false,
      openThirdPopup: false,
      
    };
  },
  updated(){
    console.log(this.itemreviews)
  },
  async mounted() {
    var r = await this.getPartners();
    // var r = await this.getReviewCountTotal();
    // this.getnoreplycount();
    // this.getaccount();
    // this.getlocation();
    // this.getpages();
    // this.getconversation();
    // this.getFilterreviews("noreviewReply");

    // this.getReviews();
    // this.getFilterreviews();
    // this.getFilterreviewsbyDate();
    // this.getStarRating();
    // ////////console.log("item location@@@:::::: getting===>", this.itemlocations);
  },
  // computed(){
  //     // this.getnoreplycount(loc);
  //     // this.getnoreplycountbu(bu_id);
  //     // this.getnoreplycountpages(page_id);
  // },
  methods: {
    bootChange(){
      this.isActive = !this.isActive;
    },
    // handleScroll() {
    //   //console.log("herere",e.srcElement.scrollTop);
    //         var currentScrollPosition = e.srcElement.scrollTop;
    //         if (currentScrollPosition > this.scrollPosition) {
    //             //console.log("Scrolling down");
    //         }
    //         this.scrollPosition = currentScrollPosition;
    // },
    selectEmoji(emoji) {
      // ////////console.log(emoji);
    },
    getImage(pic) {
      return pic;
    },

    async getPartners() {
      var partners = store.getters.getPartners;
      if (partners.length == 0) {
        this.isLoading = true;
        await store.dispatch("getPartners").then(() => {
          partners = store.getters.getPartners;
          // ////console.log("partners :: ", partners);
          this.partners = partners;
          this.partnersArray = partners;
          //////console.log("partners ::::::::: ",partners);
          return;
        });
      } else {
        this.partners = partners;
        this.partnersArray = partners;

        ////console.log("partners ::::::::: ",partners);
        return;
      }
    },
    getaccount() {
      var gbaaccounts = store.getters.getaccount;
      ////////console.log("gbaaccounts :::::::: ", gbaaccounts);
      if (gbaaccounts.length == 0) {
        this.isLoading = true;
        store.dispatch("getaccount").then(() => {
          gbaaccounts = store.getters.getaccount;
          // shuffleArray([gbaaccounts]);
          this.isLoading = false;
          this.gmbAccounts = gbaaccounts;
          ////////console.log("items accounts ::::::===>", this.gmbAccounts);
        });
      } else {
        this.gmbAccounts = gbaaccounts;
        ////////console.log("gbaaccounts@@@@@@@@####", gbaaccounts, this.gmbAccounts);
      }
      // shuffleArray([gbaAccount_items]);
      // this.items = gbaAccount_items;
    },
    getaccountbyPartner() {
      var gbaaccounts = [];
      ////////console.log("gbaaccounts :::::::: ", gbaaccounts);
      this.partner_ids = [];
      this.partner_ids.push(this.partnerSelected.id);
      //////console.log("this.partner_ids", this.partner_ids);
      // if (gbaaccounts.length == 0) {
      this.isLoading = true;
      store.dispatch("getaccountbyPartner", this.partner_ids).then(() => {
        gbaaccounts = store.getters.getaccountbyPartner;
        // shuffleArray([gbaaccounts]);
        this.isLoading = false;
        this.gmbAccounts = gbaaccounts;
        //////console.log("items accounts ::::::===>", this.gmbAccounts);
      });
      // } else {
      //   this.gmbAccounts = gbaaccounts;
      //   //////console.log("gbaaccounts@@@@@@@@####", gbaaccounts, this.gmbAccounts);
      // }
    },
    getlocation123() {
      var gbalocation = store.getters.getlocation;
      //////console.log( "item location1111 ::::::===>", gbalocation.length, this.isLoading );

      if (gbalocation.length == 0) {
        this.isLoading = true;
        store.dispatch("getlocation").then(() => {
          gbalocation = store.getters.getlocation;
          shuffleArray([gbalocation]);
          this.isLoading = false;
          this.itemlocations = gbalocation;
          this.itemlocationsArray = gbalocation;
          this.partnerSelectedlocations = gbalocation;
          this.itemlocations_city = gbalocation;
          this.itemsArray = gbalocation;
          this.idNumber = gbalocation[0].id;
          this.idNumber_bu = 0;
          // this.getReviews(gbalocation[0].id);
          this.selectedlocation = gbalocation[0];
          // //////console.log("item location@@@: :::::===>", gbalocation);
          this.getCity(gbalocation);
        });
      } else {
        this.isLoading = false;

        this.itemlocations = gbalocation;
        this.itemlocationsArray = gbalocation;
        this.partnerSelectedlocations = gbalocation;
        this.itemlocations_city = gbalocation;
        this.itemsArray = gbalocation;
        this.idNumber = gbalocation[0].id;
        this.idNumber_bu = 0;
        this.selectedlocation = gbalocation[0];
        // this.getReviews(gbalocation[0].id);
        this.getCity(gbalocation);
      }
    },
    async getlocationpaginated() {
      // var gbalocation = store.getters.getlocationbyPartner;
      ////////console.log( "item location1111 ::::::===>", gbalocation.length, this.isLoading );
      this.partner_ids = [];
      this.partner_ids.push(this.partnerSelected.id);
      // if (gbalocation.length == 0) {
      this.isLoading = true;
      var gbalocation = [];
      var payload = {
        partner_ids: this.partner_ids,
        offset: this.offset_location,
      };
      await store.dispatch("getlocationpaginated", payload).then(() => {
        gbalocation = store.getters.getlocationpaginated;
        if (gbalocation.length > 0) {
          this.isLoading = false;
          //console.log("gbalocation.length ::: ", gbalocation.length);
          this.itemlocations = [...this.itemlocations, ...gbalocation];
          this.itemlocationsArray = [
            ...this.itemlocationsArray,
            ...gbalocation,
          ];
          this.partnerSelectedlocations = [
            ...this.partnerSelectedlocations,
            ...gbalocation,
          ];
          this.itemlocations_city = [
            ...this.itemlocations_city,
            ...gbalocation,
          ];
          this.itemsArray = [...this.itemsArray, ...gbalocation];

          this.offset_location += gbalocation.length;
          //console.log("this.offset_location ",  this.offset_location, gbalocation.length)
          var aa = gbalocation.length - this.offset_location;
          //console.log("this.offset_location", aa, this.offset_location, gbalocation.length)
          if (aa == 0) {
            this.loadMore = false;
          } else {
            this.loadMore = true;Mensaje
          }
          // this.itemlocations = gbalocation;
          // this.itemlocationsArray = gbalocation;
          // this.partnerSelectedlocations = gbalocation;
          // this.itemlocations_city = gbalocation;
          // this.itemsArray = gbalocation;

          this.idNumber = this.itemlocations[0].id;
          this.idNumber_bu = 0;
          this.parter3days = false;
          this.selected_location = this.itemlocations.id;
          this.selectedlocation = this.itemlocations;
          this.getCity(this.itemlocations);
        } else {
          this.itemlocations = [];
          this.itemlocationsArray = [];
          this.partnerSelectedlocations = [];
          this.itemlocations_city = [];
          this.itemsArray = [];
          this.idNumber = "";
          this.itemreviews = [];
          this.itemreviews_data = [];
          this.porContestar = 0;
          // this.getReviews(gbalocation[0].id);
          this.selectedlocation = {};
        }
      });
    },
    async getlocationbyPartner() {
      // var gbalocation = store.getters.getlocationbyPartner;
      ////////console.log( "item location1111 ::::::===>", gbalocation.length, this.isLoading );
      this.partner_ids = [];
      this.porContestar = 0;
      this.partner_ids.push(this.partnerSelected.id);
      // if (gbalocation.length == 0) {
      this.isLoading = true;
      var gbalocation = [];
      await store
        .dispatch("getlocationbyPartner", this.partner_ids)
        .then(() => {
          gbalocation = store.getters.getlocationbyPartner;
          ////console.log("gbalocation lenght", gbalocation);
          // gbalocation.forEach((loc)=>{
          //     ////console.log("location for :: ", loc.city, loc.description);
          // });
          if (gbalocation.length > 0) {
            // shuffleArray([gbalocation]);
            this.isLoading = false;
            this.itemlocations = gbalocation;
            this.itemlocationsArray = gbalocation;
            this.partnerSelectedlocations = gbalocation;
            this.itemlocations_city = gbalocation;
            this.itemsArray = gbalocation;
            this.idNumber = gbalocation[0].id;
            this.idNumber_bu = 0;
            this.parter3days = false;
            ////console.log("gbalocation[0].id in locations for review" , gbalocation[0].id);
            this.selected_location = gbalocation[0].id;
            this.selectedlocation = gbalocation[0];
            ////console.log("selectedlocation ::::: ", this.selectedlocation);
            // ////console.log("item location@@@: :::::===>", gbalocation.length);
          } else {
            this.itemlocations = [];
            this.itemlocationsArray = [];
            this.partnerSelectedlocations = [];
            this.itemlocations_city = [];
            this.itemsArray = [];
            this.idNumber = "";
            this.itemreviews = [];
            this.itemreviews_data = [];
            this.porContestar = 0;
            // this.getReviews(gbalocation[0].id);
            this.selectedlocation = {};
          }
        });
      if (this.itemlocations.length > 0) {
        // await this.getReviews(this.itemlocations[0].id);
        await this.showIdDetails(
          this.itemlocations[0],
          this.itemlocations[0].id
        );
        // await this.getReviewCountTotal(this.itemlocations[0].id);
        await this.getCity(this.itemlocations);
      }
    },
    async getbusinessUnitbyPartner() {
      // var gbalocation = store.getters.getlocationbyPartner;
      ////////console.log( "item location1111 ::::::===>", gbalocation.length, this.isLoading );
      this.partner_ids = [];
      this.partner_ids.push(this.partnerSelected.id);
      // if (gbalocation.length == 0) {
      this.isLoading = true;
      var businessUnits = [];
      await store
        .dispatch("getbusinessUnitbyPartner", this.partner_ids)
        .then(() => {
          // console.log("getbusinessUnitbyPartner store::", store.getters);
          businessUnits = store.getters.getbusinessUnitbyPartner;
          this.businessUnits = businessUnits;
          // console.log("businessUnits lenght :::", businessUnits);
          if (businessUnits.length > 0) {
            shuffleArray([businessUnits]);
            this.isLoading = false;

            if (this.itemlocations.length > 0) {
              this.itemlocations = [...this.itemlocations, ...businessUnits];
              this.itemlocationsArray = [
                ...this.itemlocationsArray,
                ...businessUnits,
              ];
              this.partnerSelectedlocations = [
                ...this.partnerSelectedlocations,
                ...businessUnits,
              ];
              this.itemlocations_city = [
                ...this.itemlocations_city,
                ...businessUnits,
              ];
              this.itemsArray = [...this.itemsArray, ...businessUnits];
              this.idNumber_bu = businessUnits[0].id;
              this.parter3days = false;
              // this.getReviews(this.itemlocations[0].id);
              this.selected_location = this.itemlocations[0].id;
              this.selectedlocation = this.itemlocations[0];

              // this.selectedlocation = businessUnits[0];
              this.getCity(this.itemlocations);
              ////console.log("itemlocations lenght in bu", this.itemlocations);
            } else {
              this.itemlocations = businessUnits;
              this.itemlocationsArray = businessUnits;
              this.itemlocationsArray = businessUnits;
              this.partnerSelectedlocations = businessUnits;
              this.itemlocations_city = businessUnits;
              this.itemsArray = businessUnits;
              // this.idNumber_bu = businessUnits[0].id;
              this.idNumber = businessUnits[0].id;
              this.getReviewsBusinessUnit();
              this.selected_location = this.itemlocations[0].id;
              this.selectedlocation = this.itemlocations[0];

              // this.selectedlocation = businessUnits[0];
              this.getCity(this.itemlocations);
            }
          }
          // else{
          //   this.itemlocations = [];
          //   this.itemlocationsArray = [];
          //   this.partnerSelectedlocations = [];
          //   this.itemlocations_city = [];
          //   this.itemsArray = [];
          //   this.idNumber = "";
          //   this.itemreviews=[];
          //   this.itemreviews_data=[];
          //   this.porContestar=0;
          //   // this.getReviews(gbalocation[0].id);
          //   this.selectedlocation = {};

          // }
        });
    },

    getnoreplycount() {
      var partner_ids = [];
      partner_ids.push(this.partnerSelected.id);
      this.isLoading = true;
      var payload = {
        partner_ids: partner_ids,
        // "location_id" : location_id
      };
      var noreplycount = [];
      store.dispatch("getnoreplycount", payload).then(() => {
        var noreplycount = store.getters.getnoreplycount;
        //console.log("getnoreplycount store111 "+" location_id::", noreplycount);
        // noreplycount = noreply_count;
        this.noreplycount_location_data = noreplycount;
      });
      // //console.log("noreplycount in location:::::",store.getters.getnoreplycount);
      // return noreplycount
    },

    async getReviewCountTotal() {
      var partner_ids = [];
      partner_ids.push(this.partnerSelected.id);
      this.isLoading = true;
      var id = this.idNumber;
      var payload = {
        partner_ids: partner_ids,
        type: this.reviewType,
        id: id,
      };
      //console.log("payload in getReviewsCounttotal", payload);
      var reviewscount_data = [];
      await store.dispatch("getReviewCountTotal", payload).then(() => {
        reviewscount_data = store.getters.getReviewCountTotal;
        ////console.log("getnoreplycount store111 "+" location_id::", noreplycount);
        // noreplycount = noreply_count;
        var total_count = 0;
        var por_responder = 0;
        var replied = 0;

        if (reviewscount_data.length > 0) {
          reviewscount_data.forEach((data) => {
            if (data.reviewReply === false) por_responder += data.__count;
            else replied += data.__count;
          });
          //console.log("111111replied::::por_responder",replied+por_responder , por_responder);
        }
        // console.log("data :::: 1308 :: ", por_responder, total_count);
        total_count = replied + por_responder;
        por_responder = por_responder;
        this.totalreviews = total_count;
        this.porContestar = por_responder;
        // this.porContestar_general=por_responder;
        this.isLoading = false;
      });
      // //console.log("noreplycount in location:::::",store.getters.getnoreplycount);
      // return noreplycount
    },

    getnoreplycountbu(business_unit_id) {
      var partner_ids = [];
      partner_ids.push(this.partnerSelected.id);
      this.isLoading = true;
      var payload = {
        partner_ids: partner_ids,
        // "business_unit_id" : business_unit_id
      };
      var noreplycount = [];
      store.dispatch("getnoreplycountbu", payload).then(() => {
        var noreply_count = store.getters.getnoreplycountbu;
        //console.log("getnoreplycount store111 "+" location_id::", noreply_count);
        // noreplycount = noreply_count;
        this.noreplycount_bu_data = noreply_count;
      });
      // ////console.log("noreplycount :::::  ",noreplycount);
      // return noreplycount
    },

    getnoreplycountpages(page_id) {
      var partner_ids = [];
      partner_ids.push(this.partnerSelected.id);
      this.isLoading = true;
      var payload = {
        partner_ids: partner_ids,
        // "page_id" : page_id
      };
      var noreplycount = [];
      store.dispatch("getnoreplycountpages", payload).then(() => {
        var noreply_count = store.getters.getnoreplycountpages;
        //console.log("getnoreplycount store111 "+" location_id::", noreply_count);
        // noreplycount = noreply_count;
        this.noreplycount_page_data = noreply_count;
      });
      // ////console.log("noreplycount :::::  ",noreplycount);
      // return noreplycount
    },

    getnoreplylocation(id) {
      // //console.log("this.location getnoreplylocation:: ", this.itemlocationsArray ,this.noreplycount_location_data);
      var noreplycount = 0;
      if (this.noreplycount_location_data.length > 0) {
        this.noreplycount_location_data.forEach((data, index) => {
          if (data.location_id != false) {
            // //console.log("data ::: index", id, data.location_id, data.__count);
            if (data.location_id[0] === id) {
              noreplycount = data.__count;
            } else {
            }
          }
        });
      }
      return noreplycount;
    },
    getnoreplybu(id) {
      ////console.log("this.business_unit_id getnoreplybu :: ", this.businessUnits,this.noreplycount_bu_data);
      // //console.log("this.location getnoreplylocation:: ", this.businessUnits ,this.noreplycount_bu_data);
      var noreplycount = 0;
      if (this.noreplycount_bu_data.length > 0) {
        this.noreplycount_bu_data.forEach((data, index) => {
          if (data.business_unit_id != false) {
            ////console.log("data ::: index", id, data.business_unit_id, data.__count);
            if (data.business_unit_id[0] === id) {
              noreplycount = data.__count;
            } else {
            }
          }
        });
      }
      return noreplycount;
    },
    getnoreplypages(id) {
      ////console.log("this.pages in  :: ", this.itempages, this.noreplycount_page_data);
      // //console.log("this.noreplycount_page_data getnoreplylocation:: ", this.itempages ,this.noreplycount_page_data);
      var noreplycount = 0;
      if (this.noreplycount_page_data.length > 0) {
        this.noreplycount_page_data.forEach((data, index) => {
          if (data.page_id != false) {
            ////console.log("data ::: index", id, data.page_id, data.__count);
            if (data.page_id[0] === id) {
              noreplycount = data.__count;
            } else {
            }
          }
        });
      }
      return noreplycount;
    },

    getCity(gbalocation) {
      ////console.log("gbalocation in get city:: ",gbalocation);
      var city = [];
      gbalocation.forEach((loc) => {
        var count = 0;
        city.push({ name: loc.city, value: loc.city });

        // loc.review_ids.forEach((rev)=>{
        //   if(rev.reviewReply === false){
        //     count = count +1;
        //   }
        // });

        // loc['noreplycount']=count;
      });
      ////console.log("gbalocation in get city:: ",city);
      const cityunique = [
        ...new Map(city.map((item) => [item["name"], item])).values(),
      ];

      this.city = _.sortBy(cityunique, "name");
      this.cityArray = _.sortBy(cityunique, "name");
    },

    getlocationgmb_accounts(id) {
      // const id = selectedOption.id;
      ////////console.log(        "getLocationGMBAccounts :::", store.getters.getLocationGMBAccounts );
      var gbalocation = store.getters.getLocationGMBAccounts;
      if (gbalocation.length == 0) {
        this.isLocationLoading = true;
        store.dispatch("getLocationGMBAccounts", id).then(() => {
          gbalocation = store.getters.getLocationGMBAccounts;
          shuffleArray([gbalocation]);
          this.isLocationLoading = false;
          gbalocation.sort(function (a, b) {
            return a - b;
          });

          this.itemlocations = gbalocation;
          this.itemlocationsArray = gbalocation;
          this.itemsArray = gbalocation;
          ////////console.log("item location ::::::===>", this.itemlocations);
        });
      } else {
        ////////console.log();
        shuffleArray([gbalocation]);
        gbalocation.sort(function (a, b) {
          return a - b;
        });
        this.itemlocations = gbalocation;
        this.itemlocationsArray = gbalocation;
        this.itemsArray = gbalocation;
      }
    },
    getpages() {
      var gbapages = []; //store.getters.getpages;
      ////////console.log("store.getters.getpages", store.getters.getpages);
      if (gbapages.length == 0) {
        this.isLoading = true;
        store.dispatch("getpages").then(() => {
          gbapages = store.getters.getpages;
          shuffleArray([gbapages]);
          this.isLoading = false;
          gbapages.sort(function (a, b) {
            return a - b;
          });
          this.itempages = gbapages;
          this.itempagesArray = gbapages;
          gbapages.forEach((page) => {
            var count = 0;
            // //////console.log("====>", loc.locationName, "   ",loc.review_ids);
            page.review_ids.forEach((rev) => {
              // //////console.log("rev.reviewReply====", rev.reviewReply);
              if (rev.reviewReply === false) {
                count = count + 1;
                // //////console.log("count ", count);
              }
            });
            // //////console.log("loc before",loc);
            page["noreplycount"] = count;
            // //////console.log("loc after",loc);
          });

          //////console.log("item pages ::::::===>", this.itempages);
        });
      } else {
        shuffleArray([gbapages]);
        gbapages.sort(function (a, b) {
          return a - b;
        });
        this.itempages = gbapages;
        this.itempagesArray = gbapages;
      }
    },
    getpagesbyPartner() {
      var gbapages = [];
      ////////console.log("store.getters.getpages", store.getters.getpages);
      // if (gbapages.length == 0) {
      this.partner_ids = [];
      this.partner_ids.push(this.partnerSelected.id);

      this.isLoading = true;
      store.dispatch("getpagesbyPartner", this.partner_ids).then(() => {
        gbapages = store.getters.getpagesbyPartner;
        //console.log("store.getters.getpagesbyPartner" , store.getters.getpagesbyPartner);
        shuffleArray([gbapages]);
        this.isLoading = false;
        // gbapages.sort(function (a, b) {
        //     return a - b;
        //   });
        this.itempages = gbapages;
        this.itempagesArray = gbapages;
        if (gbapages.length > 0) {
          gbapages.forEach((page) => {
            var count = 0;
            // //////console.log("====>", loc.locationName, "   ",loc.review_ids);
            page.review_ids.forEach((rev) => {
              // //////console.log("rev.reviewReply====", rev.reviewReply);
              if (rev.reviewReply === false) {
                count = count + 1;
                // //////console.log("count ", count);
              }
            });
            // //////console.log("loc before",loc);
            page["noreplycount"] = count;
            // //////console.log("loc after",loc);
          });
        }

        //////console.log("item pages ::::::===>", this.itempages);
      });
      // }
      // else {
      //   shuffleArray([gbapages]);
      //   gbapages.sort(function (a, b) {
      //         return a - b;
      //       });
      //   this.itempages = gbapages;
      //   this.itempagesArray = gbapages;
      // }
    },
    getReviews() {
      // console.log("initial id number=>", loc_id);
      var gbareview = []; //store.getters.getReviews;

      // if (gbareview.length == 0) {
      // const id = loc_id; //
      ////////console.log("store.getters.getReviews id", gbareview.length, id, store.getters.getReviews);
      // this.idNumber=loc_id;

      //console.log("line 1467 :::: ",  this.idNumber, this.date, this.date!="" ,this.date!==null);
      /*var create_date = "";
      if (this.date != "" && this.date !== null) {
        create_date = moment(this.date).format("YYYY-MM-DD");
      }*/
      var create_range = []
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_range.push(start);
        create_range.push(end);
        console.log("Esto es el START",start)
        console.log("Esto es el END",end)
        console.log("Esto es el create Range",create_range)
      }
      var reviewReply_type = this.selected_tab;
      //console.log("this.starRatingSelected1577  ::: ", this.starRatingSelected);
      var payload = {
        location_id: this.idNumber,
        createTime: create_range,
        scoreTag: this.scoreTagSelected,
        starRating: Number(this.starRatingSelected),
        reviewReply_type: reviewReply_type,
        offset: this.offset_review,
        
      };
      // console.log("IMPORTANTE ---> ",payload)
      //console.log(this.itemreviews.length, this.porContestar , " :::::: gbareview");
      this.isLoadingReviewmain = true;
      store.dispatch("getReviews", payload).then(() => {
        gbareview = store.getters.getReviews;
        var count = 0;
        // var starRating = [];
        // var scoreTags = [];
        if (gbareview.length > 0) {
          // this.totalreviews = gbareview.length;
          if (gbareview.length > 0) {
            this.itemreviews = [...this.itemreviews, ...gbareview];
            this.itemreviews_data = [
              ...this.itemreviews_data,
              ...gbareview,
            ];

            //console.log("info", "reviews-", this.itemreviews);

            //console.log("this.offset_review ",  this.offset_review,this.itemreviews.length, gbareview.length)
            this.offset_review += gbareview.length;
            var aa = gbareview.length - this.offset_review;
            //console.log("this.offset_review", aa, this.offset_review, gbareview.length)
            if (aa == 0) {
              this.loadMore_review = false;
            } else {
              this.loadMore_review = true;
            }
            this.showreviewDetails(this.itemreviews[0]);
            if (this.selected_tab !== "all") {
              // this.getFilterreviews(this.selected_tab);
            }
          }
        } else {
          this.itemreviews = [];
          this.itemreviews_data = [];
        }
      });
      this.isLoadingReviewmain = false;
    },
    getReviewslast3daysCount() {
      var gbareview = []; //store.getters.getReviews;
      this.partner_ids = [];
      this.partner_ids.push(this.partnerSelected.id);
      // this.isLoadingReviewmain = true;

      store.dispatch("getReviewslast3daysCount", this.partner_ids).then(() => {
        gbareview = store.getters.getReviewsCount;
        // console.log("REVIEWS", gbareview)
        var count = 0;
        // var starRating = [];
        // var scoreTags = [];
        // this.totalreviews = gbareview.length;
        //console.log("gbareview.length 1586:: ", gbareview.length);
        this.porContestar_general = gbareview.length;
      });
      // this.isLoadingReview = false;
    },
    async getReviewslast3days() {
      var gbareview = []; //store.getters.getReviews;
      this.partner_ids = [];
      // this.porContestar=0;
      this.partner_ids.push(this.partnerSelected.id);

      var create_date = "";
      if (this.date != "" && this.date !== null) {
        create_date = moment(this.date).format("YYYY-MM-DD");
      }
      var reviewReply_type = this.selected_tab;
      var payload = {
        partner_ids: this.partner_ids,
        createTime: create_date,
        scoreTag: this.scoreTagSelected,
        starRating: Number(this.starRatingSelected),
        reviewReply_type: reviewReply_type,
        offset: this.offset_review,
      };

      this.isLoadingReviewmain = true;
      //console.log("this.isLoadingReviewmain :::: ", this.isLoadingReviewmain);
      await store.dispatch("getReviewslast3days", payload).then(() => {
        gbareview = store.getters.getReviewslast3days;
        // console.log("REVIEWS LAST 3 DAYS", gbareview)
        var count = 0;
        // var starRating = [];
        // var scoreTags = [];

        if (gbareview.length > 0) {
          // this.totalreviews = gbareview.length;
          // this.totalreviews = gbareview.length;
          if (gbareview.length > 0) {
            this.itemreviews = [...this.itemreviews, ...gbareview];
            this.itemreviews_data = [
              ...this.itemreviews_data,
              ...gbareview,
            ];
            //console.log("this.itemreviews 1651", this.itemreviews , gbareview.length);
            // this.itemreviews_data = [...this.itemreviews_data, ...gbareview];

            this.offset_review += gbareview.length;
            //console.log("this.offset_review ",  this.offset_review, gbareview.length)
            var aa = gbareview.length - this.offset_review;
            //console.log("this.offset_review", aa, this.offset_review, gbareview.length)
            if (aa == 0) {
              this.loadMore_review = false;
            } else {
              this.loadMore_review = true;
            }
            this.loadMore_review = false;
            // this.itemreviews = gbareview;
            // this.itemreviews_data = gbareview;
            //console.log(this.itemreviews,"============>", this.loadMore_review);
            this.showreviewDetails(this.itemreviews[0]);
            if (this.selected_tab !== "all") {
              // this.getFilterreviews(this.selected_tab);
            }
            this.itemreviews.forEach((i) => {
              if (i.reviewReply === false) {
                count = count + 1;
              }
            });
            // this.isLoadingReviewmain = false;
          }
        } else {
          this.itemreviews = [];
          this.itemreviews_data = [];
        }
      });
      this.isLoadingReviewmain = false;
    },
    getReviewsBusinessUnit() {
      ////////console.log("initial id number=>", loc_id);

      var gbareview = []; //store.getters.getReviews;

      // if (gbareview.length == 0) {
      // const id = bu_id; //
      ////////console.log("store.getters.getReviews id", gbareview.length, id, store.getters.getReviews);
      // this.idNumber=bu_id;
      this.isLoadingReview = true;
      var create_date = "";
      if (this.date != "" && this.date !== null) {
        create_date = moment(this.date).format("YYYY-MM-DD");
      }
      var reviewReply_type = this.selected_tab;
      var payload = {
        business_unit_id: this.idNumber,
        createTime: create_date,
        scoreTag: this.scoreTagSelected,
        starRating: Number(this.starRatingSelected),
        offset: this.offset_review,
        reviewReply_type: reviewReply_type,
      };
      this.isLoadingReviewmain = true;
      store.dispatch("getReviewsBusinessUnit", payload).then(() => {
        gbareview = store.getters.getReviewsBusinessUnit;
        var count = 0;
        var starRating = [];
        var scoreTags = [];
        if (gbareview.length > 0) {
          // this.totalreviews = gbareview.length;
          if (gbareview.length > 0) {
            this.itemreviews = [...this.itemreviews, ...gbareview];
            this.itemreviews_data = [
              ...this.itemreviews_data,
              ...gbareview,
            ];

            //console.log("store.getters.getReviewsBusinessUnit 111:::", this.itemreviews);
            this.offset_review += gbareview.length;
            //console.log("this.offset_review ",  this.offset_review, gbareview.length)
            var aa = gbareview.length - this.offset_review;
            //console.log("this.offset_review", aa, this.offset_review, gbareview.length)
            if (aa == 0) {
              this.loadMore_review = false;
            } else {
              this.loadMore_review = true;
            }
            //   this.itemreviews = gbareview;
            // this.itemreviews_data = gbareview;
            this.showreviewDetails(this.itemreviews_data[0]);
            if (this.selected_tab !== "all") {
              // this.getFilterreviews(this.selected_tab);
            }
            ////console.log("gbareview bu :::: ",gbareview);
            //////console.log("this.selected_tab111", gbareview[0], this.selected_tab);
            // this.getFilterreviews(this.type_Selected,this.selected_tab);
            this.itemreviews.forEach((i) => {
              // starRating.push(i.starRating);
              // scoreTags.push(i.score_tag);
              // ////////console.log(i.starRating);
              //console.log()
              if (i.reviewReply === false) {
                count += 1;
              }

              // if (scoreTags.length > 0) {
              //   this.scoreTagsvisible = true;
              // }
              // if (starRating.length > 0) {
              //   this.starRatingvisible = true;
              // }
              // var starRatingunique = Array.from(new Set(starRating));
              // var scoreTagsunique = Array.from(new Set(scoreTags));
              // starRatingunique.sort(function (a, b) {
              //   return a - b;
              // });
              // scoreTagsunique.sort(function (a, b) {
              //   return a - b;
              // });
              // this.starRating = starRatingunique;
              // this.scoreTags = scoreTagsunique;
              // this.porContestar = count;
              this.isLoading = false;
            });
            ////console.log("itemreviews bu :::::: ", gbareview,this.itemreviews);
          }
        } else {
          this.itemreviews = [];
          this.itemreviews_data = [];
          // this.porContestar = 0;
        }
      });
      this.isLoadingReview = false;
      this.isLoadingReviewmain = false;
    },
    getReviewsPages() {
      ////////console.log("initial id number=>", loc_id);
      var gbareview = [];
      this.itemreviewselected = [];

      // if (gbareview.length == 0) {
      // const id = loc_id; //
      // ////////console.log("store.getters.getReviews id", gbareview.length, id, store.getters.getReviews);
      // this.idNumber=loc_id;
      this.isLoading = true;

      var create_date = "";
      if (this.date != "" && this.date !== null) {
        create_date = moment(this.date).format("YYYY-MM-DD");
      }
      var reviewReply_type = this.selected_tab;

      var payload = {
        page_id: this.idNumber,
        createTime: create_date,
        scoreTag: this.scoreTagSelected,
        starRating: Number(this.starRatingSelected),
        offset: this.offset_review,
        reviewReply_type: reviewReply_type,
      };
      this.isLoadingReviewmain = true;
      store.dispatch("getReviewsPages", payload).then(() => {
        gbareview = store.getters.getReviewsPages;
        ////console.log("fffffff", gbareview);

        this.isLoading = false;
        shuffleArray([gbareview]);

        this.itemreviewselected = gbareview[0];
        var count = 0;
        var starRating = [];
        var scoreTags = [];

        if (gbareview.length > 0) {
          this.totalreviews = gbareview.length;
          if (gbareview.length > 0) {
            this.itemreviews = [...this.itemreviews, ...gbareview];
            this.itemreviews_data = [
              ...this.itemreviews_data,
              ...gbareview,
            ];

            this.offset_review += gbareview.length;
            //console.log("this.offset_review ",  this.offset_review, gbareview.length)
            var aa = gbareview.length - this.offset_review;
            //console.log("this.offset_review", aa, this.offset_review, gbareview.length)
            if (aa == 0) {
              this.loadMore_review = false;
            } else {
              this.loadMore_review = true;
            }
            // this.itemreviews = gbareview;
            // this.itemreviews_data = gbareview;
            ////////console.log(this.selected_tab);
            // this.getFilterreviews(this.selected_tab);
            this.showreviewDetails(this.itemreviews_data[0]);
            if (this.selected_tab !== "all") {
              // this.getFilterreviews(this.selected_tab);
            }
            this.itemreviews.forEach((i) => {
              // starRating.push(i.starRating);
              // scoreTags.push(i.score_tag);
              // ////////console.log(i.starRating);
              if (i.reviewReply === false) {
                count += 1;
              }

              // if (scoreTags.length > 0) {
              //   this.scoreTagsvisible = true;
              // }
              // if (starRating.length > 0) {
              //   this.starRatingvisible = true;
              // }
              // var starRatingunique = Array.from(new Set(starRating));
              // var scoreTagsunique = Array.from(new Set(scoreTags));
              // starRatingunique.sort(function (a, b) {
              //   return a - b;
              // });
              // scoreTagsunique.sort(function (a, b) {
              //   return a - b;
              // });
              // this.starRating = starRatingunique;
              // this.scoreTags = scoreTagsunique;
              // this.porContestar = count;
            });
          } else {
            this.itemreviews = [];

            // this.starRating = [];
            // this.scoreTags = [];
            // this.porContestar = 0;
          }
        }
      });
      this.isLoadingReviewmain = false;
    },
    getconversation() {
      var gbaconversation = []; //store.getters.getconversation;
      if (gbaconversation.length == 0) {
        this.isLoading = true;
        store.dispatch("getconversation").then(() => {
          gbaconversation = store.getters.getconversation;
          shuffleArray([gbaconversation]);
          this.isLoading = false;
          this.itemconversations = gbaconversation;
          this.itemsArray = gbaconversation;
          this.comentario_selected = "ToDo";
          ////////console.log("item conversation ::::::===>", this.itemconversations);
        });
      } else {
        shuffleArray([gbaconversation]);
        this.isLoading = false;
        this.itemconversations = gbaconversation;
        this.itemsArray = gbaconversation;
      }
    },
    showIdDetails(location, id) {
      //console.log("location, id", location, id);
      this.itemreviews = [];
      this.itemreviews_data = [];
      this.totalreviews = 0;
      // if(this.idNumber !== id){
      this.idNumber = id;
      this.reply_text = "";
      this.review_id = "";
      this.parter3days = false;
      // this.selected_tab="noreviewReply";
      this.selectedlocation = location;
      this.reviewType = "location";
      //   }
      // else{
      //     // this.getReviews(id);
      //     this.parter3days=false;
      // }
      // this.getReviews(id);
      this.offset_review = 0;
      this.loadMore_review = false;
      this.starRatingSelected = "";
      this.scoreTagSelected = "";
      this.date = "";

      this.type_Selected = "location";
      this.selected_location = id;
      this.selectedlocation = location;
      this.parter3days = false;
      this.selected_bu = 99999;
      this.selected_page = 9999;
      this.getReviewCountTotal();
      //console.log("calling this.getReviews");
      this.getReviews();
      //console.log("called this.getReviews");

      // this.comentario_selected="ToDo";
      ////////console.log("id changes:::: ", id);
    },
    showIdDetails_businessUnit(business_unit, id) {
      ////console.log("business_unit, id", business_unit, id, this.idNumber !== id);
      // if(this.idNumber !== id){
      this.idNumber = id;
      this.itemreviews = [];
      this.itemreviews_data = [];
      this.reply_text = "";
      this.review_id = "";
      this.totalreviews = 0;
      this.offset_review = 0;
      this.loadMore_review = false;
      // this.selected_tab="noreviewReply";
      this.selectedlocation = business_unit;
      this.starRatingSelected = "";
      this.scoreTagSelected = "";
      this.date = "";

      //   }
      // else{
      //     this.getReviewsBusinessUnit(id);
      // }
      // this.getReviewsBusinessUnit(id);
      this.offset_review = 0;
      this.type_Selected = "location";
      this.selectedlocation = business_unit;
      this.selected_location = 99999;
      this.parter3days = false;
      this.selected_bu = id;
      this.selected_page = 9999;
      this.reviewType = "business_unit";
      this.getReviewCountTotal();
      this.getReviewsBusinessUnit();
    },
    showDetails() {
      // //////console.log("location, id", location, id);
      this.offset_review = 0;
      this.loadMore_review = false;
      this.itemreviews = [];
      this.itemreviews_data = [];
      this.totalreviews = 0;
      this.reply_text = "";
      this.review_id = "";
      this.parter3days = true;

      this.type_Selected = "location";
      this.selected_location = 99999;
      this.selected_bu = 99999;
      this.selected_page = 9999;

      this.starRatingSelected = "";
      this.scoreTagSelected = "";
      this.date = "";
      this.reviewType = "partner3days";
      this.getReviewCountTotal();
      this.getReviewslast3days();
    },
    showIdDetailsPage(page, id) {
      // console
      // if(this.idNumber !== id){
      this.idNumber = id;
      this.itemreviews = [];
      this.itemreviews_data = [];
      this.totalreviews = 0;
      this.offset_review = 0;
      // this.getReviewsPages(id);

      this.type_Selected = "page";
      this.page_selected = page;
      ////console.log("page ::: ", page);
      // this.selected_tab="noreviewReply";

      // }
      // else{
      //   this.getReviewsPages(id);
      // }
      this.offset_review = 0;
      this.loadMore_review = false;
      this.reply_text = "";
      this.review_id = "";
      this.parter3days = false;
      this.selected_page = id;
      this.type_Selected = "page";
      this.page_selected = page;
      this.selected_location = 9999;
      this.selected_bu = 99999;

      this.starRatingSelected = "";
      this.scoreTagSelected = "";
      this.date = "";
      this.reviewType = "page";
      this.getReviewCountTotal();
      this.getReviewsPages();

      // this.comentario_selected="ToDo";
      ////////console.log("id changes:::: ", id);
    },
    showreviewDetails(rev) {
      this.reply_text = "";
      this.translation = false;
      this.itemreviewselected = rev;
      ////////console.log("this.itemreviewselected ", rev, this.itemreviewselected);
    },
    translate(t) {
      this.translation = !t;
      ////////console.log("this.translation ", t, this.translation);
    },
    dateSelected(range) {
      console.log(range)
      this.range = range
      this.offset_review = 0;
      this.loadMore_review = false;
      this.itemreviews = [];
      this.itemreviews_data = [];

      if (this.reviewType == "location") this.getReviews();
      if (this.reviewType == "business_unit") this.getReviewsBusinessUnit();
      if (this.reviewType == "partner3days") this.getReviewslast3days();
      if (this.reviewType == "page") this.getReviewsPages();
    },
    dateSelected12(date) {
      ////////console.log("@@@@@@@@@@@@@@@@@@@@@", date);
      ////////console.log("store.getters.getReviews id", store.getters.getReviews);
      if (date !== null) {
        var reviews = store.getters.getReviews;
        //console.log("reviews:::: ", reviews);
        var filtered_reviews = [];
        reviews.forEach((i) => {
          var date_org = new Date(i.createTime);
          var datetoFilter = new Date(date);

          var d = date_org.getDate();
          var m = date_org.getMonth() + 1;
          var y = date_org.getFullYear();

          var d_f = datetoFilter.getDate();
          var m_f = datetoFilter.getMonth() + 1;
          var y_f = datetoFilter.getFullYear();

          var dateString_org =
            y + "-" + (m <= 9 ? "0" + m : m) + "-" + (d <= 9 ? "0" + d : d);
          var dateString_filter =
            y_f +
            "-" +
            (m_f <= 9 ? "0" + m_f : m_f) +
            "-" +
            (d_f <= 9 ? "0" + d_f : d_f);
          // ////////console.log(dateString_org, " from date conversation ::: ", dateString_filter);
          if (dateString_org === dateString_filter) {
            filtered_reviews.push(i);

            // ////////console.log(" from date conversation data::: ", i);
          }
        });
        if (filtered_reviews.length > 0) {
          this.showreviewDetails(filtered_reviews[0]);
        }
        this.itemreviews = filtered_reviews;
        // ////////console.log("itemreviews filtered no reviewReply ::: ", this.itemreviews);
      } else {
        var id = this.idNumber;
        this.getReviews();
      }
    },
    getSortedreviews(sortdata) {
      var reviews = this.itemreviews;

      if (sortdata === "reviewReplyAsc") {
        var filtered_reviews = [];
        reviews.sort(function (a, b) {
          return a.comment_eng.localeCompare(b.comment_eng);
        });
        ////////console.log("sortData reviews @@@@@ ::: ", reviews);

        this.showreviewDetails(reviews[0]);

        this.itemreviews = reviews;
      } else if (sortdata === "reviewReplyDesc") {
        // reviews.sort(function(a,b){return b.comment_eng - a.comment_eng})
        var filtered_reviews = [];
        reviews.sort(function (a, b) {
          // return a.comment - b.comment
          return b.comment_eng.localeCompare(a.comment_eng);
        });
        // sorted_review.forEach((i) => {
        //  filtered_reviews.push(i);
        // });
        // ////////console.log(filtered_reviews);
        this.showreviewDetails(reviews[0]);
        this.itemreviews = reviews;
      } else if (sortdata === "createTimeAsc") {
        var filtered_reviews = [];
        reviews.sort(function (a, b) {
          var b_date = new Date(b.createTime).getTime();
          var a_date = new Date(a.createTime).getTime();
          var c = a_date - b_date;
          return c;
        });

        this.showreviewDetails(reviews[0]);
        this.itemreviews = reviews;
      } else if (sortdata === "createTimeDesc") {
        var filtered_reviews = [];
        reviews.sort(function (a, b) {
          var b_date = new Date(b.createTime).getTime();
          var a_date = new Date(a.createTime).getTime();
          var c = b_date - a_date;
          return c;
        });
        // sorted_review.forEach((i) => {
        //  filtered_reviews.push(i);          });
        ////////console.log(reviews);
        this.showreviewDetails(reviews[0]);
        this.itemreviews = reviews;
      } else {
      }
    },

    getfilterlocationName() {
      ////////console.log("here ", this.itempages.length, this.gmbAccounts.length);
      // var arr = [];
      // arr=this.gmbAccounts;
      // arr.unshift(this.itempages[0]);
      // ////////console.log("arr=====>",arr);
      if (this.gmbAccounts.length > 0) {
        const filteredlocation = this.gmbAccounts.filter((link) => {
          if (link.name === false) {
            ////////console.log("link else", link);
          } else {
            ////////console.log("link location", link);
            return link.name
              .toLocaleLowerCase()
              .match(this.locationName.toLocaleLowerCase());
          }
        });
        ////////console.log("filteredlocation", filteredlocation);
        this.gmbAccounts = filteredlocation;
      }
      if (this.itempages.length > 0) {
        const filteredlocation1 = this.itempages.filter((link) => {
          if (link.name === false) {
            ////////console.log("link else", link);
          } else {
            return link.name
              .toLocaleLowerCase()
              .match(this.locationName.toLocaleLowerCase());
          }
        });
        ////////console.log("filteredlocationpages", filteredlocation1);
        this.itempages = filteredlocation1;
      } else {
      }
    },
    async getfilterlocationNamePartner() {
      //console.log("here ",  this.partnerSelected );
      this.citySelected = null;
      this.offset_review = 0;
      if (this.partnerSelected === null) {
        //////console.log("111");
        // if(Object.keys( this.citySelected).length !== 0 ){
        //   //////console.log("222");
        //   this.getfilterlocationNameCity();
        // }else{
        //   //////console.log("333");
        // this.getlocation();
        // this.getpages();
        this.itemlocations = [];
        this.itemlocationsArray = [];
        this.partnerSelectedlocations = [];
        this.itemlocations_city = [];
        this.itemsArray = [];
        this.idNumber = "";
        this.itemreviews = [];
        this.itemreviews_data = [];
        this.porContestar = 0;
        // this.getReviews(gbalocation[0].id);
        this.selectedlocation = {};
        this.itempages = [];
        this.itempagesArray = [];
        this.gmbAccounts = [];
        this.offset_location = 0;
        // }
      } else {
        this.itemlocations = [];
        this.itemlocationsArray = [];
        this.partnerSelectedlocations = [];
        this.itemlocations_city = [];
        this.itemsArray = [];
        this.idNumber = "";
        this.itemreviews = [];
        this.itemreviews_data = [];
        this.porContestar = 0;
        // this.getReviews(gbalocation[0].id);
        this.selectedlocation = {};
        this.itempages = [];
        this.itempagesArray = [];
        this.gmbAccounts = [];
        this.offset_location = 0;
        if (Object.keys(this.partnerSelected).length === 0) {
          //////console.log("not selected");
          this.itemlocations = [];
          this.itemlocationsArray = [];
          this.partnerSelectedlocations = [];
          this.itemlocations_city = [];
          this.itemsArray = [];
          this.idNumber = "";
          this.itemreviews = [];
          this.itemreviews_data = [];
          this.porContestar = 0;
          // this.getReviews(gbalocation[0].id);
          this.selectedlocation = {};
          this.itempages = [];
          this.itempagesArray = [];
          this.gmbAccounts = [];
          this.offset_location = 0;
        } else {
          // await this.getaccountbyPartner();
          // await this.getReviewslast3days();
          this.porContestar_general = 0;
          this.offset_location = 0;
          this.offset_review = 0;
          this.itemreviews = [];
          this.itemreviews_data = [];
          this.porContestar = 0;

          // await this.getnoreplycount();
          // console.log("this.platformSelected.value ", this.platformSelected);

          if (this.platformSelected !== null) {
            if (this.platformSelected.value === "GMB") {
              await this.getnoreplycountpages();
              await this.getnoreplycountbu();
              await this.getnoreplycount();
              // await this.getlocationpaginated();
              await this.getlocationbyPartner();
              await this.getReviewslast3daysCount();
            } else if (this.platformSelected.value === "Trustpilot") {
              await this.getnoreplycountpages();
              await this.getnoreplycountbu();
              await this.getnoreplycount();
              // await this.getlocationpaginated();
              await this.getbusinessUnitbyPartner();
              await this.getReviewslast3daysCount();
            } else if (this.platformSelected.value === "Facebook") {
              await this.getnoreplycountpages();
              await this.getnoreplycountbu();
              await this.getnoreplycount();
              // await this.getlocationpaginated();
              await this.getpagesbyPartner();
              await this.getReviewslast3daysCount();
            } else {
              await this.getnoreplycountpages();
              await this.getnoreplycountbu();
              await this.getnoreplycount();
              // await this.getlocationpaginated();
              await this.getlocationbyPartner();
              await this.getReviewslast3daysCount();
              // await this.getReviewslast3days();
              await this.getbusinessUnitbyPartner();
              await this.getpagesbyPartner();
            }
          } else {
            await this.getnoreplycountpages();
            await this.getnoreplycountbu();
            await this.getnoreplycount();
            // await this.getlocationpaginated();
            await this.getlocationbyPartner();
            await this.getReviewslast3daysCount();
            // await this.getReviewslast3days();
            await this.getbusinessUnitbyPartner();
            await this.getpagesbyPartner();
          }

          //await this.getpages();
          //////console.log("=>>>>>>>>>>>>>>>>>", this.city, this.itemsArray);
          //////console.log("selected>>>>>>>>",  this.itemlocations,"===",  this.partnerSelected.name);
          if (this.itemsArray.length > 0) {
            var city_filtered = [];
            const filteredcity = this.itemlocations_city.filter((link) => {
              //////console.log("this.partnerSelected.id === link.partner_id.id ::::", this.partnerSelected.id, link.partner_id.id);
              ////console.log("this.partnerSelected[0] === link.partner_id :: ", this.partnerSelected , link.partner_id[0]);
              if (link.city !== false) {
                if (this.partnerSelected.id === link.partner_id[0]) {
                  // //////console.log(link.city);
                  city_filtered.push({ name: link.city, value: link.city });
                  return link.city;
                } else {
                }
              }
            });

            //////console.log("filteredcity::::", city_filtered.length);

            const cityunique = [
              ...new Map(
                city_filtered.map((item) => [item["name"], item])
              ).values(),
            ];

            this.city = _.sortBy(cityunique, "name");
            //////console.log("city::::", this.city.length, this.cityArray.length);
          }
          if (this.itemsArray.length > 0) {
            //////console.log("this.itemlocations.length ::::", this.itemlocations.length, this.partnerSelected);
            const filteredlocation = this.itemlocationsArray.filter((link) => {
              //////console.log("link111 ::::", link);
              if (link.partner_id === undefined) {
              } else {
                // ////console.log("===========>",link.partner_id[1], this.partnerSelected.value);
                return link.partner_id[1]
                  .toLocaleLowerCase()
                  .match(this.partnerSelected.value.toLocaleLowerCase());
              }
            });
            this.itemlocations = filteredlocation;
            this.partnerSelectedlocations = filteredlocation;
            // this.itemlocationsArray = filteredlocation;
            //////console.log("=====",filteredlocation.length);
          }
          if (this.itempagesArray.length > 0) {
            const filteredlocation1 = this.itempagesArray.filter((link) => {
              // //////console.log("link.partner_id",link.partner_id.name !== undefined , link.partner_id.name !== false, (link.partner_id.name !== false || link.partner_id.name !== undefined) );
              if (link.partner_id.name === undefined) {
                // //////console.log("link else", link);
              } else {
                // //////console.log("link.partner_id.name", link.partner_id.name);
                return link.partner_id.name
                  .toLocaleLowerCase()
                  .match(this.partnerSelected.name.toLocaleLowerCase());
              }
            });
            // //////console.log("filteredlocationpages", filteredlocation1);
            this.itempages = filteredlocation1;
          } else {
          }
        }
      }
    },
    async getfilterplatform() {
      this.locations = [];
      this.itemlocations = [];
      this.businessUnits = [];
      this.itempages = [];
      this.itempagesArray = [];
      //console.log("this.platformSelected111 ::: ", this.platformSelected);
      await this.getfilterlocationNamePartner();

      // if(this.platformSelected !== null){
      //    await this.getnoreplycountpages();
      //     await this.getnoreplycountbu();
      //     await this.getnoreplycount();
      //     // await this.getlocationpaginated();
      //     await this.getlocationbyPartner();
      //     await this.getReviewslast3daysCount();

      //   if(this.platformSelected.value === "GMB"){
      //       await this.getlocationbyPartner();
      //   }
      //   else if(this.platformSelected.value === "Trustpilot"){
      //       await this.getbusinessUnitbyPartner();

      //   }
      //   else if(this.platformSelected.value === "Facebook"){
      //       await this.getpagesbyPartner();
      //   }

      // }
      // else{
      //   await this.getfilterlocationNamePartner();
      // }
    },
    getfilterlocationNameCity() {
      //////console.log("here ",  this.citySelected );
      // //////console.log("this.partnerSelected.length", Object.keys( this.partnerSelected).length);
      // this.itemlocations = this.itemlocationsArray;
      //////console.log("this.itemlocations.length ::::", this.itemlocations.length);
      if (this.citySelected === null) {
        this.itemlocations = this.itemlocationsArray;
        this.partnerSelected === null;
        // this.itemlocations = this.itemlocationsArray;
        this.itempages = this.itempagesArray;
        if (Object.keys(this.partnerSelected).length === 0) {
          // this.getlocation();
          // this.getpages();
        } else {
          this.getfilterlocationNamePartner();
        }
      } else {
        if (Object.keys(this.citySelected).length === 0) {
          //////console.log("not selected");
        } else {
          //////console.log("selected",  this.citySelected.value,  this.citySelected.name, this.itemlocationsArray.length);
          if (this.partnerSelectedlocations.length > 0) {
            //////console.log("this.itemlocations.length ::::", this.partnerSelectedlocations.length);
            const filteredlocation = this.partnerSelectedlocations.filter(
              (link) => {
                //console.log("link city 2395", link);
                if (
                  link.city === undefined ||
                  link.city === "" ||
                  link.city === false
                ) {
                } else {
                  return link.city
                    .toLocaleLowerCase()
                    .match(this.citySelected.name.toLocaleLowerCase());
                }
              }
            );
            this.itemlocations = filteredlocation;
            //////console.log("=====",filteredlocation.length);
          }
          if (this.itempagesArray.length > 0) {
            const filteredlocation1 = this.itempagesArray.filter((link) => {
              // //////console.log("link.partner_id",link.partner_id.name !== undefined , link.partner_id.name !== false, (link.partner_id.name !== false || link.partner_id.name !== undefined) );
              //console.log("link city ::::", link);
              if (
                link.city === undefined ||
                link.city === "" ||
                link.city === false
              ) {
                // //////console.log("link else", link);
              } else {
                // //////console.log("link.partner_id.name", link.partner_id.name);
                return link.city
                  .toLocaleLowerCase()
                  .match(this.citySelected.name.toLocaleLowerCase());
              }
            });
            // //////console.log("filteredlocationpages", filteredlocation1);
            this.itempages = filteredlocation1;
          } else {
          }
        }
      }
    },
    getfilterlocationNamePartner1(data) {
      //////console.log("here ", this.partners, data );
      // var arr = [];
      // arr=this.gmbAccounts;
      // arr.unshift(this.itempages[0]);
      // ////////console.log("arr=====>",arr);
      if (this.itemlocations.length > 0) {
        //////console.log("this.itemlocations.length :::: ", this.itemlocations.length);

        const filteredlocation = this.itemlocations.filter((link) => {
          if (link.partner_id !== false || link.partner_id !== undefined) {
            // if(link.partner_id.name
            //     .toLocaleLowerCase().match(this.partner_search))
            //   {
            //     ////////console.log("link location", link.partner_id.name);
            //   }
            return link.partner_id.name
              .toLocaleLowerCase()
              .match(this.partner_search.toLocaleLowerCase());
          } else {
            ////////console.log("link else", link);
          }
        });
        ////////console.log("filteredlocation", filteredlocation);
        this.itemlocations = filteredlocation;
      }
      if (this.itempages.length > 0) {
        const filteredlocation1 = this.itempages.filter((link) => {
          // //////console.log("link.partner_id",link.partner_id.name !== undefined , link.partner_id.name !== false, (link.partner_id.name !== false || link.partner_id.name !== undefined) );
          if (
            link.partner_id.name === false ||
            link.partner_id.name === undefined
          ) {
            // //////console.log("link else", link);
          } else {
            // //////console.log("link.partner_id.name", link.partner_id.name);
            return link.partner_id.name
              .toLocaleLowerCase()
              .match(this.partner_search.toLocaleLowerCase());
          }
        });
        // //////console.log("filteredlocationpages", filteredlocation1);
        this.itempages = filteredlocation1;
      } else {
      }
    },
    getfilterlocationNameCity1() {
      ////////console.log("here ", this.itempages.length, this.gmbAccounts.length);
      // var arr = [];
      // arr=this.gmbAccounts;
      // arr.unshift(this.itempages[0]);
      // ////////console.log("arr=====>",arr);
      if (this.itemlocations.length > 0) {
        //////console.log("this.itemlocations.length :::: ", this.itemlocations.length);

        const filteredlocation = this.itemlocations.filter((link) => {
          if (link.city === false) {
            // //////console.log("link else", link.city);
          } else {
            // //////console.log("link location", link.city);
            return link.city
              .toLocaleLowerCase()
              .match(this.city_search_location.toLocaleLowerCase());
          }
        });
        ////////console.log("filteredlocation", filteredlocation);
        this.itemlocations = filteredlocation;
      } else {
      }
    },

    getfilterlocation() {
      ////////console.log("here ", this.locationName, this.itemlocations);
      const filteredlocation = this.itemlocations.filter((link) => {
        if (link.locationName === false) {
          ////////console.log("link else", link);
        } else {
          return link.locationName
            .toLocaleLowerCase()
            .match(this.locationName.toLocaleLowerCase());
        }
      });
      ////////console.log("filteredlocation", filteredlocation);
      this.itemlocations = filteredlocation;
    },
    // async getFilterreviewsSelected(type, value) {
    //   var reviews = store.getters.getReviews;
    //   var filtered_reviews = [];

    //   if (type == "starRating") {
    //     reviews.forEach((i) => {
    //       if (i.starRating === value) {
    //         filtered_reviews.push(i);
    //       }
    //       this.itemreviews = filtered_reviews;
    //     });
    //   } else if (type == "scoreTags") {
    //     reviews.forEach((i) => {
    //       if (i.score_tag === value) {
    //         filtered_reviews.push(i);
    //       }
    //       this.itemreviews = filtered_reviews;
    //     });
    //   } else {

    //   }
    // },

    getfilterReviewName() {
      ////////console.log("here ", this.search_review, this.itemreviews_data);
      const filteredlocation = this.itemreviews.filter((link) => {
        if (link.location_id.city !== undefined) {
          return link.location_id.city
            .toLocaleLowerCase()
            .match(this.search_review.toLocaleLowerCase());
        } else {
          ////////console.log("link else", link);
        }
      });
      ////////console.log("filteredlocation", filteredlocation);
      this.itemreviews = filteredlocation;
      this.showreviewDetails(this.itemreviews[0]);
    },
    async getFilterreviewsSelected(type, value) {
      var reviews = store.getters.getReviews;
      var filtered_reviews = [];
      this.offset_review = 0;
      this.loadMore_review = false;
      this.itemreviews = [];
      this.itemreviews_data = [];
      //console.log("in getFilterreviewsSelected this.itemreviews ::: ", this.itemreviews.length);
      // this.porContestar=0;
      if (type == "starRating") {
        this.starRatingSelected = value;
        this.scoreTagSelected = "";
        if (this.reviewType == "location") this.getReviews();
        if (this.reviewType == "business_unit") this.getReviewsBusinessUnit();
        if (this.reviewType == "partner3days") this.getReviewslast3days();
        if (this.reviewType == "page") this.getReviewsPages();
        // reviews.forEach((i) => {
        //   if (i.starRating === value) {
        //     filtered_reviews.push(i);
        //   }
        //   this.itemreviews = filtered_reviews;
        // });
      } else if (type == "scoreTags") {
        this.starRatingSelected = "";
        this.scoreTagSelected = value;
        if (this.reviewType == "location") this.getReviews();
        if (this.reviewType == "business_unit") this.getReviewsBusinessUnit();
        if (this.reviewType == "partner3days") this.getReviewslast3days();
        if (this.reviewType == "page") this.getReviewsPages();
        // reviews.forEach((i) => {
        //   if (i.score_tag === value) {
        //     filtered_reviews.push(i);
        //   }
        //   this.itemreviews = filtered_reviews;
        // });
      } else {
        this.starRatingSelected = "";
        this.scoreTagSelected = "";
      }
    },
    async getFilterreviews(opcion) {
      ////////console.log("In filter review", opcion);
      //reviewReply noreviewReply all
      ////////console.log("store.getters.getReviews id", store.getters.getReviews);
      //console.log("in getFilterreviews this.itemreviews ::: ", this.itemreviews.length);
      this.offset_review = 0;
      this.loadMore_review = false;
      this.itemreviews = [];
      this.itemreviews_data = [];

      if (opcion == "noreviewReply") {
        // var reviews = store.getters.getReviews;
        // var reviews = this.itemreviews_data;
        ////////console.log("this.itemreviews_data", this.itemreviews_data);
        // this.selected_tab="";
        var filtered_reviews = [];
        // await this.getReviewCountTotal();
        this.selected_tab = "noreviewReply";

        if (this.reviewType == "location") {
          this.itemreviews = [];
          this.itemreviews_data = [];
          this.getReviews();
        }
        if (this.reviewType == "business_unit") this.getReviewsBusinessUnit();
        if (this.reviewType == "partner3days") this.getReviewslast3days();
        if (this.reviewType == "page") this.getReviewsPages();

        // reviews.forEach((i) => {
        //   ////////console.log("=======@@@@@@",i);
        //   if (i.reviewReply === false) {

        //     filtered_reviews.push(i);
        //   }
        // });

        // this.showreviewDetails(filtered_reviews[0]);
        // this.itemreviews = filtered_reviews;
        // ////console.log("filtered_reviews@@@@=======>", filtered_reviews)
        this.por_responder_tab = "";
        this.respondidos_tab = "active";
        this.all_tab = "";
        ////////console.log(          "itemreviews filtered no reviewReply ::: ", this.itemreviews);
      }
      if (opcion == "reviewReply") {
        // var reviews = this.itemreviews_data;
        // var filtered_reviews = [];

        this.selected_tab = "reviewReply";
        this.respondidos_tab = "";
        this.all_tab = "";

        if (this.reviewType == "location") this.getReviews();
        if (this.reviewType == "business_unit") this.getReviewsBusinessUnit();
        if (this.reviewType == "partner3days") this.getReviewslast3days();
        if (this.reviewType == "page") this.getReviewsPages();

        // reviews.forEach((i) => {
        //   if (i.reviewReply !== false) {
        //     filtered_reviews.push(i);
        //   }
        // });
        // ////console.log("filtered_reviews!!!=======>", filtered_reviews)
        // this.showreviewDetails(filtered_reviews[0]);
        // this.itemreviews = filtered_reviews;
      }
      if (opcion == "all") {
        this.selected_tab = "all";

        var id = this.idNumber;
        // this.itemreviews = this.itemreviews_data;
        ////////console.log("##########3", this.itemreviews );
        this.por_responder_tab = "";
        this.respondidos_tab = "";
        this.all_tab = "active";
        // this.showreviewDetails(this.itemreviews[0]);

        if (this.reviewType == "location") this.getReviews();
        if (this.reviewType == "business_unit") this.getReviewsBusinessUnit();
        if (this.reviewType == "partner3days") this.getReviewslast3days();
        if (this.reviewType == "page") this.getReviewsPages();

        ////////console.log("in all id ", id);
        // this.showIdDetails(id);
      }
      // else {
      //   // var id = 2;

      //   this.selected_tab="noreviewReply";
      //   this.por_responder_tab="active";
      //   this.respondidos_tab="";
      //   this.all_tab="";

      //   // this.showIdDetails(this.itemreviews_data, id);
      // }
    },
    resolvedChange(id,value){
      var review_id = id
      var resuelto = value
      var cambio = {
        resuelto: resuelto,
        review_id: review_id
      };
      store.dispatch("resolveChanged", cambio).then((res) => {
      console.log("El Cambio se han enviado")
        
      })
    },
    scoreTagChange(id,value){
      var review_id = id
      var value = value
      var payload = {
        review_id: review_id,
        cambio: {"score_tag":value}
      };
      store.dispatch("scoreChange", payload).then((res)=> {
        console.log("El cambio se ha enviado")
      })
    },
    reviewReplySubmit(id) {
      ////////console.log("In submit", this.reply_text, id);
      var reply_text = this.reply_text;
      var review_id = id;
      var reply = {
        reply_text: reply_text,
        review_id: review_id,
      };
      store.dispatch("reviewReplyWizard", reply).then((res) => {
        this.reply_text = "";
        var loc_id = this.idNumber;
        //////console.log("locid type", this.type_Selected, loc_id, res);
        this.selected_location = [];

        this.cookies = true;
        this.message = "Mensaje enviado con éxito";
        this.showIdDetails(this.selected_location, loc_id);
      });
    },
    reviewReplyDelete(id) {
      ////////console.log("In Delete", id);
      var review_id = id;

      store.dispatch("getreviewDelete", review_id).then((res) => {
        var loc_id = this.idNumber;
        ////////console.log("locid type", this.type_Selected, loc_id);
        this.selected_location = [];
        this.showIdDetails(this.selected_location, loc_id);
      });
    },

    insert(emoji) {
      this.reply_text += emoji;
    },
    show() {
      ////////console.log("this.$store ::::: ", this.$store.state.location);
      return this.$store.state.location;
    },
    getString(item) {
      var desc = item.description;
      var city = item.city;
      var str = [desc, city].filter(Boolean).join(" - ");

      // this.location_info=str;
      return str;
    },
    getString1(item) {
      var averageRating = item.averageRating;
      var regionCode = item.regionCode;
      var str = [averageRating, regionCode].filter(Boolean).join(" - ");

      // this.location_info=str;
      return str;
    },
    getStringbu(item) {
      var score = item.score;

      var country_code = item.country_code;
      var str = [score, country_code].filter(Boolean).join(" - ");

      // this.location_info=str;
      return str;
    },
    getdateConverted(datestr) {
      // console.log("datestr :: ", datestr);
      var val_date = "";
      var time = "";
      var datepart = "";
      var x = "";
      if (datestr != "" && datestr != false) {
        x = datestr.split(" ");
        // var datepart = x[0];
        // console.log("datestr 2788 :: ", datestr, x);

        if (x.length > 0) {
          time = x[1];
          var datesplit = x[0].split("-");
          if (datesplit.length > 0)
            datepart = datesplit[2] + "/" + datesplit[1] + "/" + datesplit[0];
        }
      }
      val_date = datepart + " " + time;
      // console.log(val_date);
      return val_date;
    },
    getStringReview(type_Selected, item) {
      
      var desc = "";
      var city = "";
      desc = item.description;
      city = item.location_city;

      var str = [desc, city].filter(Boolean).join(" - ");
      return str;
    },
    getStringReview1(type_Selected, item) {
      var averageRating = "";
      var regionCode = "";
      averageRating = item.averageRating;
      regionCode = item.regionCode;

      var str = [averageRating, regionCode].filter(Boolean).join(" - ");
      return str;
    },
    getStringReviewbu(type_Selected, item) {
      //console.log("item in review", type_Selected, item);
      // var desc = this.selectedlocation.description;
      var desc = "";
      var city = "";
      desc = item.business_unit_description;
      city = item.business_unit_city;
      var str = [desc, city].filter(Boolean).join(" - ");

      return str;
    },
    getStringReviewbu1(type_Selected, item) {
      var score = "";
      var country_code = "";

      score = item.score;

      country_code = item.country_code;
      var str = [score, country_code].filter(Boolean).join(" - ");

      return str;
    },
    getStringBuReview(item) {
      ////console.log("item in getStringBuReview", this.selected_bu);
      var api_name = this.selected_bu.api_name;
      var country_code = this.selected_bu.country_code;
      var str = [api_name, countrygetReviews()]
    },
  watch: {
    locationName: function (val) {
      //////console.log("==================>");

      if (val.length >= 1) {
        this.getfilterlocationName();
      } else if (val.length == 0) {
        // this.getaccount();
        // this.getpages();
      }
    },
    // city_search_location: function (val) {

    //   if (val.length >= 1) {
    //     this.getfilterlocationNameCity();
    //   } else if (val.length == 0) {
    //     // this.getaccount();
    //     // this.getpages();
    //     this.getlocation();
    //   }
    // },
    // partnerSelected: function (val) {
    //   //////console.log("val", val);
    //   if (Object.keys(val).length > 0) {
    //     this.getfilterlocationNamePartner();
    //   }
    //    if (val == null) {
    //     this.itempages = this.itempagesArray;
    //     this.itemlocations = this.itemsArray;
    //   }
    // },
    partner_search: function (val) {
      //////console.log("partner_search ::: ", val);
      this.partner_ids = val;
      if (val.length >= 1) {
        this.offset_review = 0;
        this.platformSelected = {};
        this.getfilterlocationNamePartner();
        // this.getnoreplycountpages();
        // this.getnoreplycountbu();
        // this.getnoreplycount();
        // this.getnoreplycount();
        // this.getbusinessUnitbyPartner();
        this.getcity();
      } else if (val.length == 0) {
        // this.getaccount();
        // this.getpages();
        // this.getlocation();
      }
    },
    // search_review: function (val) {
    //   if (val.length >= 3) {
    //   ////////console.log("val:::", val);
    //     this.getfilterReviewName();
    //   } else if (val.length == 0) {
    //   // ////////console.log("val11:::", val, this.itemreviews_data);
    //     this.itemreviews=this.itemreviews_data;
    //   }
    // },
  },
  color(value) {
    let $color;
    if (value <= 25) {
      $color = "info";
    } else if (value > 25 && value <= 50) {
      $color = "success";
    } else if (value > 50 && value <= 75) {
      $color = "warning";
    } else if (value > 75 && value <= 100) {
      $color = "danger";
    }
    return $color;
  }
}
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<!--<style>
  @import './assets/css/custom.css';
</style>-->
<style >
.newPop{
  display: flex;
  justify-content: space-between;
}
.change{
  width: 100%;
  height: 100%;
}

.hide{
  display: none;
}
.tabnav .nav-link {
  display: block;
  padding: 0.5rem 5px;
  font-size: 12px;
}
.firstcol .card-body {
  padding: 10px 7px;
}

/* This demo uses Tailwind v0.6.4 */

/*
.emoji-invoker {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
}*/
.emoji-invoker:hover {
  transform: scale(1.1);
}
.emoji-invoker > svg {
  fill: #b1c6d0;
}

.emoji-picker {
  position: absolute;
  z-index: 1;
  font-family: Montserrat;
  border: 1px solid #ccc;
  width: 15rem;
  height: 20rem;
  overflow: scroll;
  padding: 1rem;
  box-sizing: border-box;
  border-radius: 0.5rem;
  background: #fff;
  box-shadow: 1px 1px 8px #c7dbe6;
}
.emoji-picker__search {
  display: flex;
}
.emoji-picker__search > input {
  flex: 1;
  border-radius: 10rem;
  border: 1px solid #ccc;
  padding: 0.5rem 1rem;
  outline: none;
}
.emoji-picker h5 {
  margin-bottom: 0;
  color: #b1b1b1;
  text-transform: uppercase;
  font-size: 0.8rem;
  cursor: default;
}
.emoji-picker .emojis {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.emoji-picker .emojis:after {
  content: "";
  flex: auto;
}
.emoji-picker .emojis span {
  padding: 0.2rem;
  cursor: pointer;
  border-radius: 5px;
}
.emoji-picker .emojis span:hover {
  background: #ececec;
  cursor: pointer;
}
.slide-data-btn {
  border: none;
  background: #3c4b64;
  border-radius: 50px;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  padding: 12px 20px;
  text-align: center;
}
.firstcol .firstcol-list-wrapper {
  height: 753px;
  overflow-x: hidden;
}
.hideButton{
  border-radius: 8%;
  font-family: Montserrat;
  border: none;
}
@media only screen and (max-width: 991px) {
  .list-item-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
  }
  .firstcol .firstcol-list-wrapper {
    height: auto;
  }
  .firstcol .list-item-wrapper {
    overflow-x: auto;
  }
  .firstcol .list-item-wrapper > a {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 41.66667%;
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
    margin-right: 1rem !important;
    border-top-width: 1px;
  }
}
.info-lg-btn {
  font-size: 15px;
  color: #407bec;
  background: white;
  border: 1px solid;
}
.info-lg-btn i {
  color: #407bec !important;
}
.flexear{
  display: flex;
  justify-content: space-between;
}
.boxbutton{
  padding-left: 30%;
}


</style>